export default {
  months: {
    jan: 'Janeiro',
    feb: 'fevereiro',
    mar: 'Em março',
    apr: 'abril',
    may: 'Em maio',
    jun: 'Junho',
    jul: 'Em julho',
    aug: 'agosto',
    sep: 'setembro',
    oct: 'Outubro',
    nov: 'novembro',
    dec: 'dezembro',
  },
  all: 'todos',
  day: 'dia',
  one_month: '1 mês',
  three_months: '3 meses',
  six_months: '6 meses',
  one_year: '1 ano',
  increase: 'aumentar',
  deduction: 'reduzir',
  new: 'Novo',
  past: 'acabado',
  memo: 'Nota',
  enter_memo: 'Por favor insira uma nota.',
  price: 'Preço',
  enrollment: 'Inscrição',
  re_enter: 'Reentrar',
  registration_complete_txt: 'O registro está completo',
  registration_failed_txt: 'O registro falhou.',
  bank_name: 'nome do banco',
  locale_name: 'Português',
  sale_registration: 'Registro de venda',
  apply: 'aplicação',
  status: 'estado',
  wallet: 'carteira',
  buy: 'Comprar',
  sell: 'venda',
  breakdown: 'Repartição',
  act_buy: 'Comprar',
  act_sell: 'Comprar',
  asset: 'ativos',
  select: 'seleção',
  no_select: 'não selecionado',
  account: 'contas',
  balance: 'saldos',
  login: 'login',
  logout: 'sair',
  register: 'Inscrever-se',
  select_cancel: 'Desmarque',
  cancel: 'cancelado',
  modify: 'cristal',
  auto_input: '(Entrou automaticamente)',
  confirm: 'confirmação',
  look_up: 'referência',
  password: 'senha',
  account_delete: 'secessão',
  detail: 'mais',
  list_detail: 'mais detalhes',
  birth: 'aniversário',
  welcome: 'Bem-vindo.',
  please_login: 'Por favor login.',
  confirmation_login: 'Você pode verificá-lo quando fizer login.',
  id: 'Nome de Usuário',
  find_id: 'Procurar ID',
  find_password: 'Esqueceu a senha',
  back: 'retorno',
  agreement: 'Termos do acordo',
  info_input: 'informações de entrada',
  success: 'completo',
  agree_msg: 'Concordo.',
  all_agree: 'Concordo com tudo',
  agree: 'Aceita',
  confirm_password: 'Confirme a Senha',
  repeat_password: 'Confirme a Senha',
  next: 'Próximo',
  before: 'Volte',
  register_success: 'Registre-se agora.',
  verify: 'confirmação',
  retention: 'retenção',
  allow: '(Aceite)',
  disallow: '(Inaceitável)',
  upload_btn: 'Por favor soltar arquivos, ou clique aqui.',
  continue_entry:
    'Por favor, indique o seu: "[+:verification]" Para continuar abaixo.',
  login_msg_1: 'Coin relacionadas com contas Tente em ONEWORLDPAY !',
  login_msg_2:
    'Através da nossa ONEWORLDPAY utilize o negócio e carteiras e serviços.',
  login_msg_3: 'ONEWORLDPAY pode suportar todos os ambientes.',
  cocofx_register: 'ONEWORLDPAY Register',
  register_msg_1:
    'Participar como membro. <br /> Por favor, concorda com os nossos termos e condições',
  register_msg_3:
    'Uma conta ONEWORLDPAY dará acesso a todos os serviços à vontade.',
  register_msg_all:
    'O consentimento para todos inclui o consentimento para itens obrigatórios e opcionais, e você pode selecionar o consentimento individualmente. Mesmo se você se recusar a concordar com as opções, o serviço estará disponível.',
  register_title: 'Estou acima da idade de 19 e mais velhos.',
  register_title_2: 'Condições ONEWORLDPAY',
  register_title_3: 'ONEWORLDPAY Integração Termos de serviço',
  register_title_4: 'ONEWORLDPAY comercialização alavancagem concordou',
  register_title_5: 'A coleta eo uso de informações pessoais consentimento',
  register_title_6: 'A coleta e uso de acordo informações de localização',
  register_title_7: 'Concordo informações de perfil adicionais a cobrar',
  register_title_8: 'Entrada ONEWORLDPAY Informações da Conta',
  register_title_9: 'Informações de entrada',
  register_msg_4:
    'Esses termos se aplicam a todos os serviços prestados pela empresa. <br /> Ao concordar com estes termos, você pode usar esses serviços sem a assinatura de um contrato separado.',
  required: '[Requeridos]',
  option: '[Seletivo]',
  otp_notice: 'O estado é ativado e desativado OTP impossível.',
  required_check: 'Verifique todos os campos obrigatórios',
  check_input: 'Por favor, indique todos os detalhes.',
  register_guide: 'Como usar ONEWORLDPAY',
  register_step1: 'Clique COCO BANK Botão',
  register_step2: 'Entre para COCO BANK',
  register_step3: 'Pagamento / Recharge COCO BANK Sessão',
  copy: 'copiando',
  no_account: 'Há contas não registradas.',
  inviter_link: 'links de referência',
  register_used_account: 'Cadastre contas frequentemente utilizadas',
  security_certification: 'Certificação de segurança',
  company: 'empresa',
  exact_calculation: 'ajuste',
  profile: 'Informações membro',
  inquiry: 'inquérito',
  announcement: 'notificações',
  information: 'informações',
  history: 'história',
  registration_date: 'Data de registro',
  pay: 'Forma de pagamento',
  detail_search: 'Full Text Search',
  market: 'mercado',
  holding: 'segurando',
  fee_charged: 'Taxa cobrada',
  type_of_charge: 'Tipo de cobrança',
  auto: 'Automático',
  manual: 'manual',
  s_usdt_protocol: 'Escolha um protocolo Tether',

  header: {
    c2c_enroll: 'Compra / Venda',
    wallet_list: 'Carteira / História &',
    wallet: 'carteira',
    c2c_list: 'histórico de compras / vendas',
    no_c2c_sell_list: 'Não há histórico de vendas.',
    transfer_list: 'História Câmbios',
    no_transfer_list: 'Não há histórico de troca.',
    withdrawal_list: 'Entrada / História Retirada',
    my_info: 'minha Informação',
    home: 'Maine',
    payment_history: 'Histórico de faturamento',
    account_transfer: 'Transferência de conta',
    transfer_history: 'histórico de transferências',
    register_used_account: 'Cadastre contas frequentemente utilizadas',
    exchange: 'para troca',
    exchange_store: 'troca',
    exchange_list: 'História Câmbios',
    email: 'E-mail',
    email_list: 'História e-mail',
    otp: 'OTP',
    otp_list: 'História OTP',
    register_account: 'conta de registo',
    calculation_account_list: 'Liquidação lista de contas',
    security_certification: 'Certificação de segurança',
    exact_calculation: 'ajuste',
    history: 'história',
    coco_open_market: 'COCO Open Market',
    information: 'informações',
    my_profile: 'minha Informação',
    email_modify: 'Editar e-mail',
    password_modify: 'Edite sua senha',
    inquiry: 'inquérito',
    inquiry_history: 'Detalhes de contato',
    one_on_one_inquiry: '1:1 inquérito',
    frequently_asked_questions: 'FAQ',
    announcement: 'notificações',
    notice: 'notificações',
    server_notice: 'anúncios de servidor',
    service_center: 'centro de serviço',
    profile: 'Informações membro',
    company: 'empresa',
    account_management: 'Gerenciamento de Contas',
    do_exchange: 'para troca',
    transfer: 'transferências',
    look_up: 'referência',
    faq: 'FAQ',
    server: 'servidor',
    email_request: 'e-mail Contacto',
    Balance_transfer_history: 'Detalhes do saldo',
    no_balance_transfer_history:
      'Não há histórico de movimento de equilíbrio de mercado.',
    manual: 'Manual',
  },
  header_sub: {
    exchange_list: 'História Câmbios',
    transfer_list: 'histórico de transferências',
  },
  footer: {
    footer_msg: 'Aproveite as contas relacionadas com a moeda em ONEWORLDPAY!',
    footer_sub_msg:
      'Através da nossa ONEWORLDPAY utilize as transações e serviços de carteira',
    footer_sub_msg2: 'ponta',
    footer_sub_msg3: 'ONEWORLDPAY pode suportar todos os ambientes.',
    ICO: 'ICO',
    c2c: 'C2C Troca',
    b2c: 'trocas B2C',
    margin_exchange: 'margem de câmbio',
    futures_exchange: 'Bolsa de futuros',
    Binary: 'Opções binárias',
    open_marcket: 'Open Market',
    game: 'jogos',
    proceed: 'transações em andamento',
    public: 'IPO Notícias',
    direct_ex: 'troca direta',
    buy: 'Comprar',
    sell: 'Comprar',
    buy_sell: 'Compra / venda',
    holding_coin: 'segurando moeda',
    fee: 'Guia de taxa',
    exchange: 'troca',
    transfer_record: 'Histórico de negociação',
    Leverage: 'influência',
    live_exchange: 'ao vivo Negociação',
    demo_exchange: 'demo Trading',
    contest: 'rali',
    powerball: 'Powerball',
    law:
      'Legal: número de registo do ONEWORLDPAY.COM: 70638826927 (U 6 29 Railway Pde EastwoodNSW 2122)',
    law1:
      'Negociação Ponto de Instrumentos Financeiros O proprietário de todo o Ltd (Austrália) é ONEWORLDPAY PTY Ltd Número de registo: 70638826927 marca.',
    law2:
      'Este site é alimentado por ONEWORLDPAY Corp. ONEWORLDPAY Corp aprovado número 64.190 - estão sob a regulação do serviço de finanças Auxiliary, é registado no número de referência 70638826927 Austrália.',
    law3:
      'ONEWORLDPAY opera de acordo com as diretrizes de investimento produtos financeiros australianos.',
    law4:
      'ref. não. 538324 | reg ABN. 70638826927 | reg BA. 64190. Para se certificar de que você está autorizado a utilizar os serviços ONEWORLDPAY nas disposições legais do país de residência é da exclusiva responsabilidade do cliente.',
    law5: 'Por favor, leia a Divulgação de Risco profissional ONEWORLDPAY.',
    law6:
      'não ONEWORLDPAY não prestação de serviços aos Estados Unidos, Belize, Ilhas Maurícias, Japão, Alberta, British Columbia, Quebec, Saskatchewan Moradores de Saskatchewan, Haiti, Suriname, a Coreia do Norte, Porto Rico e da área ocupada de Chipre.',
    law7:
      'Por favor, consulte a parte reguladora do FAQ para mais informações. Consulte a nossa Divulgação de Risco.',
    law8:
      'As áreas restritas: se a Trading Point of Financial Instruments Ltd não fornece o investimento e serviços auxiliares para os países do terceiro mundo e regiões.',
    law_warn: 'Aviso de Risco:',
    law_1:
      'CFD tem um risco elevado e produtos complexos rapidamente perder seu dinheiro devido à alavancagem. 69,10% dos investidores individuais respondem ele vai perder dinheiro quando da negociação de CFD.',
    law_2:
      'Você deve considerar se você pode aceitar o fato de que você entenda o CFD funciona, maior o risco de perder dinheiro. Consulte a nossa Divulgação de Risco.',
    alert_title: 'Nota e nota',
    coco_market: 'COCO Mercado',
    ieo_market: 'IEO Mercado',
    news: 'Notícia',
    event: 'evento',
    platform_rental_title: 'aluguer de plataformas',
    education: 'Educação',
    online_Academy: 'Academia on-line',
    offline_Academy: 'Academia offline',
    shopping_basket: 'Cesta de compras',
    best_product: 'Melhores negócios',
    order: 'ordem',
    my_page_title: 'minha página',
    member_info_management: 'Gerenciamento de Contas',
    order_management: 'Order Management',
    my_question: 'minha pergunta',
    one_enquiry: '01:01 Contato',
    community: 'comunidade',
    lotto: 'Loteria Powerball',
    rock_event: 'rocha Evento',
    quiz_game: 'Trivia Game',
    ladder_game: 'Escada',
    tetris: 'Tetris',
    split_lotto: 'Lotto dividida',
    day_Lottery: 'loteria diária',
    attendance: 'verificação de atendimento',
    scoop_out: 'Embutir',
    forum: 'fórum',
  },
  b2c_exchange: {
    trading_view: 'TradingView',
    basic_chart: 'gráfico básico',
    today_hight: 'Preço alto (mesmo dia)',
    today_row: 'Preço baixo (mesmo dia)',
    tightening_strength: 'Força de aperto',
    h24_volume: 'Volume (24H)',
    h24_transaction_amount: 'Valor da transação (24H)',
    previous_days_closing_price: 'Preço de fechamento do dia anterior',
    auxiliary_indicator: 'Indicador auxiliar',
    unlimited_number:
      'Você pode selecionar um número ilimitado de indicadores. ',
    rod_type: 'Tipo de haste',
    chart_type: 'Tipo de Gráfico',
    market_name: 'Nome do mercado',
    present_price: 'Preço atual',
    compared_to_the_previous_day: 'Em comparação com o dia anterior',
    volume: 'Volume',
    coin_name_and_symbol_search: 'pesquisar nome / símbolo da moeda',
    event: 'evento',
    asking_price_window: 'Janela de cotação',
    sell_order: 'Vender',
    buying_order: 'comprando',
    limits: 'limites',
    maximum_order_price_quantity: 'Quantidade máxima de preço do pedido',
    direct_input: 'Entrada direta',
    order_classification: 'Classificação do pedido',
    order_available: 'Pedido disponível',
    order_quantity: 'Quantidade do pedido',
    total_order_amount: 'Valor total do pedido',
    quantity_user_fee_rate: 'Quantidade Taxa de taxa do usuário',
    quantity_creator_fee_rate: 'Taxa de taxa de criador de quantidade',
    reset: 'Redefinir',
    conclusion_price: 'Preço de conclusão',
    tightening_amount: 'Quantidade de aperto',
    execution_time: 'Tempo de execução',
    execution_price: 'Preço de execução',
    execution_quantity: 'Quantidade do contrato',
    execution_amount: 'Montante de execução',
    order_date_and_time: 'Data e hora do pedido',
    transaction_coin: 'Moeda de transação',
    order_price: 'Preço do pedido',
    untraded_quantity: 'Quantidade não comercializada',
    state: 'Estado',
    current_price: 'Preço atual',
    division: 'divisão',
    transaction_price: 'Preço de transação',
    week52_high: 'Máximo de 52 semanas',
    week52_minimum: '52 semanas no mínimo',
    days_closing_price: 'Preço de fechamento do dia anterior',
    same_day_high_price: 'Preço alto no mesmo dia',
    low_price_on_the_day: 'Preço baixo no dia',
    average_price: 'Preço médio',
    cumulative_quantity: 'Quantidade cumulativa',
    cumulative_amount: 'Montante cumulativo',
    selection: 'Seleção',
    minimum_ask_quantity: 'Maior quantidade de pedidos',
    save: 'Salve',
    accounts_that_can_be_traded: 'Não há conta disponível para negociação.',
    won_pay: 'KRW',
    coin_order: 'ordem',
    asking_price: 'Perguntar o preço',
    chart: 'Gráfico',
    quote: 'Citar',
    order_details: 'Detalhes do pedido',
    account_number: 'Número da conta',
    moving_quantity: 'Quantidade em movimento',
    registration_date: 'Data de registro',
  },
  main_msg: {
    about_1_title: 'O mundo melhor serviços de negociação de senhas moeda',
    about_1_msg:
      'Todos os serviços, correspondente à moeda levando ONEWORLDPAY.',
    about_1_1_msg:
      'Disponível para a primeira moeda criptomoeda tempo, as vendas em um único lugar no mundo.',
    about_1_2_msg: 'Quanto à troca direta está disponível a ONEWORLDPAY.',
    about_2_title: 'Imediatamente sistema de troca',
    about_2_msg:
      'ONEWORLDPAY usando uma tecnologia de combinação estáveis ​​multi-paralelo aplicar imediatamente as tecnologias de design avançado para habilitar o Exchange Stocks Exchange System.',
    about_3_title: 'carteira gerado',
    about_3_msg:
      'Os especialistas em segurança foram ONEWORLDPAY é composta pelos melhores engenheiros na Coréia Equipado com sistema de segurança state-of-the-art fornece sistema de carteira.',
    about_4_title: 'sistemas de negociação simples (C2C)',
    about_4_msg:
      'ONEWORLDPAY é construir um simples, sistema de negociação user-friendly Vamos permitir que uma transação mais conveniente.',
    c2c_main_msg1_1:
      'ONEWORLDPAY irá trocar imediatamente, usando tecnologia de correspondência multi-paralelo confiável',
    c2c_main_msg1_2:
      'Segure o sistema de troca, aplicando as técnicas de design avançado para ativar e',
    c2c_main_msg1_3: 'Há sim.',
    c2c_main_msg2_1:
      'Os especialistas em segurança foram ONEWORLDPAY é composta pelos melhores engenheiros na Coréia',
    c2c_main_msg2_2:
      'Equipado com sistema de segurança state-of-the-art fornece sistema Wallet.',
    c2c_main_msg3_1:
      'ONEWORLDPAY é mais fácil de sistema de negociação user-friendly construção',
    c2c_main_msg3_2: 'Ele permite a fácil negociação.',
  },
  toasted_msg: {
    confirm: 'Ele foi identificado',
    changed: 'Mudanças foram',
    withdrawal: 'retirada foi',
    register: 'Foi registrado.',
    delete: 'Ele foi excluído.',
    title: 'notificações',
    exchange: 'troca direta foi processado com êxito.',
    search: 'Era visto.',
    deposit_request: 'Aplicação foi depositado.',
    withdraw_request: 'Retirada tem vindo a aplicar.',
    create_account: 'Ele foi aberto.',
    modify: 'Ele foi corrigido.',
    cancel: 'Ele foi cancelada.',
    trade_confirm: 'Negociação tenha sido estabelecida.',
    trade_reject: 'Negócio negado.',
    copy: 'Copiado.',
    nice_msg:
      'Se você não tem que ser desativado nas configurações do seu navegador pop-up de autenticação de identidade não procede normalmente.',
    nice_title: 'informações',
    nice_success: 'autenticação de identidade foi processado com êxito.',
    nice_error: 'Não é possível verificar a sua identidade.',
    no_transfer: 'Sem troca de informações.',
    email_auth: 'autenticação de e-mail é concluída com êxito.',
    email_auth_send: 'Este e-mail foi enviado para certificação.',
    kyc_withdraw: 'autenticação de conta foi bem sucedida.',
    not_allow_trade: 'Deal é inativo.',
    id_find_mail_send: 'ID foi enviado por e-mail.',
    duplicate_check: 'ID duplicado ou e-mail.',
    pay: 'O pagamento está completo.',
    msg_holding: 'Foi realizada.',
    msg_read_care: 'Nota Será que você leia e compreenda as informações?',
    answer_care: 'Eu estava ciente de quatro',
    continuation: 'continuar',
    continue_entry:
      'Por favor, indique o seu: "[+:verification]" Para continuar abaixo.',
  },
  private: {
    market_name: 'Nome do mercado',
    deal_list: 'Histórico de vendas',
    app_list: 'histórico de compras',
    app_detail: 'compras Detalhe',
    deal_buy_asset: 'Ativos a serem comprados',
    buy_price: 'preço de compra',
    confirmed_source_amount: 'Confirmar Vendas',
    holding_source_amount: 'Vendas não confirmados',
    potential_source_amount: 'Quantidade disponível',
    direct_market: 'troca direta',
    deal_enroll: 'vender',
    app_enroll: 'para Compra',
    select_market: 'Select Market',
    fee_rate: 'comissão',
    free: 'livre',
    deal_info_input: 'Digite Informações de Vendas',
    deal_source_amount: 'de vendas',
    deal_price: 'Preço por unidade',
    deal_enroll_account: 'Conta para Vender',
    account_select: 'Selecione Conta',
    direct_asset_select: 'Por favor, escolha uma propriedade venda e compra',
    please_select_asset: 'Por favor, selecione um ativo.',
    basic_rate: 'preço atual',
    direct_transfer_buy: 'a compra imediata',
    direct_transfer_sell: 'Imediatamente no momento da venda',
    direct_source_amount: 'Unidade de câmbios',
    direct_target_amount: 'aplicar Quantidade',
    direct_asset_buy: 'Compre {0}',
    direct_asset_sell: 'As vendas para {0}',
    selected_deal_info: 'Informações de vendas selecionados',
    deal_source_asset_title: 'bens adquiridos',
    deal_total_source_amount: 'volume total de vendas',
    app_info_input: 'Digite Informações de compra',
    app_amount: 'volume de compras',
    app_deal_price: 'preço',
    pay_target_amount: 'Quantidade pago para fazer',
    fee: 'comissão',
    fee_calc: 'valor da taxa',
    msg_fee_calc: 'Como {0} será deduzido.',
    app_account: 'Conta de Compra',
    app_receive_account: 'Selecione a conta a receber',
    c2c_buy_select_asset:
      'Por favor, selecione a divulgação das vendas ser adquiridos na principal',
    go_home: 'Voltar à página',
    buy_calc_spread: 'Moeda de compra',
    sell_calc_spread: 'Moeda sell',
    cs_market_asset: 'ativos par',
    cs_market_basic_rate: 'taxa de referência de marketing',
    transfer_type: 'Tipo de câmbio',
    exchange_rate: 'taxa de câmbio',
    submit_transfer: 'trocarão imediatamente',
    deal_source_min_amount: 'A quantidade de compra mínima',
    closed_date: 'terminar um',
    no_deal: 'Nenhuma lista de vendas',
    app_price_per_quantity: 'Preço por Unidade',
    app_fee_amount: 'total de taxas',
    select_deal_app_list: 'Compras de vendas selecionados',
    no_select_deal_app_list: 'Não há compras em suas vendas',
    transfer_source_amount: 'Com base na quantidade de ativos',
    transfer_target_amount: 'Para os ativos Quantidade',
    transfer_basic_rate: 'taxa de referência aplicada a venda',
    transfer_spread_rate: 'spreads das taxas de aplicação',
    transfer_exchange_rate: 'taxa de câmbio',
    transfer_list_detail: 'Permuta Para mais detalhes',
    transfer_source_asset: 'Baseado em ativos',
    transfer_target_asset: 'para os ativos',
    transfer_source_account_number: 'Com base no número de conta de ativos',
    transfer_target_account_number: 'Para o número de conta de ativo',
    transfer_detail_type: 'Tipo de câmbio',
    transfer_regdate: 'Aplique uma',
    transfer_asset_info: '{0} a {1} {2}',
    transfer_asset_select:
      'Por favor, selecione o recurso que deseja substituir.',
    msg_transfer_buy: 'Compre {0}',
    msg_transfer_sell: 'As vendas para {0}',
    deal_fee_amount: 'Despesas de venda Divulgação partido impostas',
  },
  wallet_page: {
    total_amount: 'Retirada total',
    have_asset: 'ativos',
    asset_list: 'Lista de Ativos',
    account_list: 'Lista de contas',
    account_create: 'criação de conta',
    deposit: 'depósito',
    withdraw: 'retirada',
    deposit_list_look: 'depósito Lookup',
    deposit_look: 'depósito Visualizações',
    withdraw_list_look: 'Retirada History &',
    withdraw_look: 'retirada Visualizações',
    account_modify: 'Modificar Conta',
    deposit_apply: 'Aplicação depósito',
    withdraw_apply: 'aplicação retirado',
    deposit_request_amount: 'Montante da caução',
    withdraw_request_amount: 'retirada Valor',
    withdraw_account_info: 'Retirada Informações da Conta',
    holder_name: 'Conta Detentor do Nome',
    bank_name: 'Nome do Banco',
    withdraw_bank_address: 'Número de conta',
    withdraw_address: 'endereço do imóvel',
    qr_address: 'endereço da conta',
    create_qr_address: 'Conta Discurso de Abertura',
    account_enroll: 'O registo da conta',
    account_seq: 'número de identificação da conta',
    account_title: 'Nome da conta',
    account_msg: 'Por favor, insira o nome da sua conta para mudar.',
    regdate: 'Gaeseolil',
    before_regdate: '(Antes de abertura)',
    holding_balance: 'Pare o montante',
    select_asset: 'Select propriedade',
    create: 'inaugurado',
    deposit_list: 'depósito',
    no_deposit_list: 'Não há detalhes do pedido de depósito.',
    deposit_apply_detail: 'Depósito Peça mais detalhes',
    asset_title: 'ativo',
    request_amount: 'montante solicitado',
    withdraw_list: 'História retirada',
    no_withdraw_list: 'Não há pedido de retirada.',
    withdraw_apply_detail: 'Retirada Peça mais detalhes',
    withdraw_fee_total_amount: 'Retirada total (incluindo taxas)',
    net_amount: 'valor final',
    fee_type: 'tipo de taxa',
    create_account_address: 'Conta Discurso de Abertura',
    deposit_msg:
      'Depositar minha carteira {0} {0} do lado de fora da carteira.',
    deposit_msg_1:
      'Uma vez aprovados 350 vezes (confirmação) na cadeia bloco {0} operações estão reflectidas na carteira.',
    deposit_step_1: 'Passo 1. Verifique a ID {0} memorandos em primeiro lugar.',
    deposit_step_1_1: 'Meu notas ID {0}',
    deposit_step_1_2:
      '{0} deve marcar suas próprias notas ID quando você deposita. {0}, sem notas de transferência de ID é perdido.',
    deposit_step_1_3: 'Veja o seu {0} endereço Wallet.',
    deposit_step_1_btn: 'Notes ID Copiar',
    deposit_step_2: 'Passo 2. Verifique se o seu endereço de carteira.',
    deposit_step_2_1: 'QR code',
    deposit_step_2_2: 'carteira Endereço',
    deposit_step_2_3:
      'O depósito mínimo é <span style = "color:#4a90e2"> {0} {1} é </ span>.',
    deposit_step_2_btn: 'Bolsa Copiar endereço',
    deposit_msg_2: 'verifique',
    deposit_msg_2_1: 'Este é o endereço para o único depósito.',
    deposit_msg_2_2:
      'O tempo total necessário para se conformar conclusão pode ser afetado por congestionamento da rede de cadeia de bloco, criptomoeda estrelas Block encadeamento congestionamento é <span style = "color: #4a90e2; cursor: pointer;"> aqui </span> você pode verificar.',
    no_account_list: 'Não há lista de contas.',
    no_favorite_account_list: 'Não existe uma lista de contas favorita.',
    enter_wallet_adress: 'Digite o endereço da carteira',
  },
  my_page: {
    my_profile: 'minha Informação',
    user_name: 'nome de usuário',
    email_address: 'E-mail',
    register_regdate: 'desde',
    last_login: 'Último login em',
    auth_complete: 'certificado',
    not_auth: 'não certificada',
    expdate: 'expiração',
    act_auth: 'autenticação',
    realname_auth: 'autenticação de identidade',
    email_auth: 'autenticação de e-mail',
    otp_auth: 'autenticação OTP',
    enroll: 'inscrição',
    security: 'Nível de segurança',
    show_security: 'Ver Nível de Segurança',
    auth_withdraw_address: 'Autenticação Endereço retirada',
    apply_list: 'aplicar Histórico',
    password_modify: 'Edite sua senha',
    email_modify: 'Editar e-mail',
    account_block: 'Conta retirada',
    placeholder_old_password: 'Por favor, indique a sua senha antiga',
    placeholder_new_password: 'Por favor digite sua nova senha',
    placeholder_confirm: 'Por favor, indique mais uma vez',
    placeholder_password: 'Digite sua senha',
    placeholder_email: 'Insira um novo e-mail',
    mail_cert_list: 'Histórico aplicativo de e-mail',
    no_mail_list: 'Não há histórico da aplicação de e-mail.',
  },
  kyc: {
    str_birth: 'data de nascimento',
    enter_adress: 'Por favor, insira o endereço do ativo.',
    register_account: 'conta de registo',
    kyc_enroll: 'Os pedidos de autenticação KYC',
    auth: 'certificado',
    auth_code_send: 'Enviando o código de autenticação',
    auth_code: 'Código de autenticação',
    msg_auth_code: 'Digite o código de verificação dentro de 5 minutos.',
    type_title: 'Nome do tipo',
    withdraw_auth: 'Autenticação Endereço retirada',
    select_asset: 'Select propriedade',
    select_bank: 'Select Bank',
    holder_name: 'Conta Detentor do Nome',
    birth: 'data de 6 dígitos de nascimento',
    address: 'endereço do imóvel',
    withdraw_list: 'Retirada Conta História Aplicação',
    bank_name: 'Nome do Banco',
    withdraw_info: 'Retirada Informações da Conta',
    withdraw_complete: 'A propriedade já completou esta certificação.',
    regdate: 'adicionado',
    delete_withdraw_address: 'endereço de débito Changed',
    delete_success_address: 'O endereço retirada mudou.',
    kyc_cert_list: 'KYC História Aplicação',
    no_kyc_list: 'KYC há histórico aplicação.',
    no_kyc_withdraw_address_list:
      'Não há histórico de aplicação de conta de pagamento.',
  },
  otp: {
    enter_verification_number: 'Insira um número de autenticação OTP',
    otp_auth: 'autenticação OTP',
    authenticode: 'Chaves OTP',
    otp_deactivate: 'OTP com deficiência',
    msg_authenticator_installation:
      'O app "Google Authenticator", por favor instalar em seu smartphone ou no seu desktop',
    android: 'andróide',
    or: 'ou',
    iphone_series: 'iPhone, iPad e iPod',
    windows_phone: 'Windows Phone',
    and: 'e',
    msg_microsoft_other_systems:
      'Outros sistemas, incluindo área de trabalho Microsoft Windows',
    msg_key: 'a chave',
    msg_use_loss_change:
      'Por favor, escreva no papel. Perdeu ou terminal é usado quando você precisa mudar o OTP.',
    msg_brcode_touch:
      'Execute o aplicativo "Google Authenticator" Preços Por favor, tocando no <b> Verificar QR código de barras </ b> na parte inferior da tela.',
    msg_input_authenticode:
      'Digite o código de verificação exibido na tela do terminal no "Código de Autenticação" abaixo.',
    otp_key: 'Chaves OTP',
    otp_activate: 'activação OTP',
    otp_copy: 'As chaves de OTP copiado.',
    otp_safe_keeping:
      'Menos então fez a chave OTP em papel e armazená-lo em um lugar seguro?',
    yes: 'quatro',
    otp_register: 'inscrição',
    otp_register_success: 'O registro OTP foi concluída com êxito.',
    otp_delete_success: 'cancelamento OTP do registro é concluído com êxito.',
    msg_click_key_copy: 'Clique na chave copiada.',
    otp_login: 'Entrada OTP',
  },
  security: {
    show_security: 'Ver Nível de Segurança',
    grade: 'classificação',
    condition: 'condição',
    restriction: 'limitações',
    no_grade: 'Mudeunggeup',
    no: 'qualquer',
    security_title:
      'Limitações critérios de classificação de segurança específicas',
    banner1: 'Segurança confiável',
    banner2:
      'Para a compra ou venda através ONEWORLDPAY, ONEWORLDPAY deve garantir a criptografia de dados, monitoramento de transações em tempo real, a política de proteção de comprador e vendedor, e todos os seus pagamentos através de um ONEWORLDPAY recebeu seguro de checkout e pagamento esquema.',
    banner_invite: 'ONEWORLDPAY não tem uma conta?',
    banner_join: 'Registre-se Gratuitamente',
    banner3: 'Como ONEWORLDPAY é manter nossos clientes seguros',
    content1_h3: 'Buyer Protection',
    content1_text:
      'Se o comprador ohbaesong desgaste ou danos mibaesong, ONEWORLDPAY pode compensar o valor do pagamento total, incluindo custos de envio para as operações elegíveis. *',
    content2_h3: 'Vendedor de Proteção',
    content2_text:
      'Se você receber um pagamento não autorizado ou reivindicações mibaesong contra o vendedor na venda são elegíveis, você pode receber o valor integral de proteção. *',
    content3_h3: 'Criptografia de dados',
    content3_text:
      'conexões TLS, HTTPS para ajudar a manter o pagamento, a chave pinagem de aplicativos móveis, a conformidade PCI mais seguro.',
    content3_btn: 'PCI Compliance',
    content4_h3: 'Prevenção de fraude',
    content4_text:
      'Todas as transações são monitoradas em tempo real, através da análise de sua conta e suporte para evitar atividades fraudulentas e faturamento.',
    sec_h2: 'Cheque Compre',
    sec_text:
      'ONEWORLDPAY porque a transação monitoramento 24 horas por dia, 365 dias quando detecta diferente algo de costume entrar em contato com o comprador pede-lhe para confirmar o seu login ou compra. Também verifica ONEWORLDPAY para todas as compras e vendas via e-mail.',
    wran_h2: 'Se você encontrar alguns pontos suspeitos',
    warn_step1: 'Relatório.',
    warn_step1_text1:
      'Depois de confirmar os detalhes não tenham encontrado um acordo aprovado',
    warn_step1_text2:
      'Comunicar um problema> relatório de actividade não autorizada',
    warn_step1_text3: 'Clique ou contato imediatamente ONEWORLDPAY.',
    warn_step2: 'Verifique se há outros problemas.',
    warn_step2_text1:
      'Comente definições recentes de atividade comercial e da conta para se certificar de que os encargos adicionais ou alterações, por favor, também relatar essas informações.',
    warn_step3: 'Por favor, altere sua senha.',
    warn_step3_text1:
      'Pode nas configurações da conta no menu Segurança. Ou, se você não conseguir fazer login na sua conta',
    warn_step3_text2: 'Login> logging Problemas',
    warn_step3_text3: 'Clique para obter reiniciado.',
    warn_btn: 'Relatar transações não autorizadas',
    online_h2: 'suportes ONEWORLDPAY seguros atividades online.',
    online_h3: 'Segurança da conta',
    online_text: 'Proteger a sua conta com uma senha altamente segura.',
    online_btn: 'Saiba mais',
  },
  input: {
    id: 'ID de entrada',
    password: 'uma senha de entrada (8-32 dígitos com caracteres especiais)',
    repeat_password: 'Confirme a Senha',
    user_name: 'Nome de usuário de entrada',
    email_address: 'E-mail de entrada de endereço',
  },
  oauth: {
    contact_msg: 'Quer acesso às seguintes informações no aplicativo {0}.',
    agree_msg: '{0} Você concorda que o acesso a {1} `s informações pessoais?',
    agree_info:
      'A informação fornecida será utilizada / guardada por um período de serviço para a identificação do usuário, estatísticas, contas vinculadas CS e similares. Informações básicas e fornecer os itens necessários são as informações que devem ser fornecidas para usar os serviços ONEWORLDPAY.',
    agree_request: 'ofertas',
    agree_msg2:
      'Uma vez acordado, a informação será gerido em conformidade com os Termos e Condições e da Política de Privacidade do serviço.',
    agree: 'para concordar',
  },
  pay_head_foot: {
    account_management: 'Gerenciamento de contas',
    settlement_account_list: 'Lista de contas de liquidação',
    account_summary_views: 'Resumo da conta Visualizações',
    fund: 'fundos',
    history: 'Histórico de faturamento',
    help: 'Ajuda',
    qa: 'Fale conosco',
    fee: 'comissão',
    secure: 'segurança',
    go_shop: 'compras',
    my_info: 'meu perfil',
    my_page: 'Configurações de conta',
    out: 'sair',
    in: 'login',
    about: 'sobre',
    blog: 'Blogs',
    employ: 'Jobs',
    site_map: 'Mapa do site',
    developer: 'revelador',
    partner: 'parceiro',
    privacy_state: 'política de Privacidade',
    usage: 'Termos de Uso',
    feed_back: 'feedback',
    warn_to_consumer:
      'Notificação aos clientes: os proprietários dos meios pré-pagos de pagamento ONEWORLDPAY ⓒ ONEWORLDPAY All rights reserved não requer a aprovação da Autoridade de Supervisão Financeira da Austrália. Por favor, leia atentamente os termos e condições.',
  },
  continue: 'continuação',
  pay_home: {
    cocobank_title: 'COCO Banco',
    platform: 'plataforma',
    platform_rental: 'alugar plataformas',
    cocopay_is: 'ONEWORLDPAY é o crescimento do negócio',
    help: 'Ajudando.',
    home_banner_1:
      'Ampliando a base de clientes potenciais em todo o mundo, e para facilitar a gestão de pagamentos,',
    home_banner_2:
      'Negócios Vendedor de Proteção *, e permitir seguro comprar na monitoramento 24/7 fraude.',
    home_banner_3: 'Você pode mais facilmente ter sucesso.',
    home_banner_warn:
      '* Termos e Condições aplicam-se ao vendedor de protecção. Por favor, consulte o seu contrato para obter detalhes sobre a elegibilidade.',
    home_banner_join: 'Registre-se grátis.',
    home_sec1_openShop: 'Você pode abrir uma loja em ONEWORLDPAY.',
    home_sec1_btn: 'para lidar',
    home_sec2_h2: 'Obter o método de pagamento desejado.',
    home_sec2_text1:
      'ONEWORLDPAY também pode receber pagamentos on-line, móvel, e até mesmo e-mail.',
    home_sec2_text2:
      'Se o ONEWORLDPAY vendidos em qualquer lugar que pode ajudar com o pagamento mais fácil e mais seguro.',
    home_sec2_online_pay: 'Pagamento online',
    home_sec2_online_text:
      'botões de pagamento para facilitar o conjunto disponível ONEWORLDPAY é muito útil quando receber pagamentos em dinheiro e pagamentos periódicos, doações, etc. Com ONEWORLDPAY Caixa, os clientes podem fazer pagamentos mais rápida e facilmente.',
    home_sec2_online_more: 'Veja mais sobre o pagamento on-line',
    home_sec2_voice_invoice: 'email fatura',
    home_sec2_voice_text:
      'solicitação de e-mail fácil para pagamento ao profissional gratuita a factura. clientes no exterior, bem como estão disponíveis para clientes que não são da conta ONEWORLDPAY.',
    home_sec2_voice_more: 'Veja mais sobre faturas de e-mail',
    home_sec2_exchange_pay: 'Efetue um pagamento na bolsa',
    home_sec2_exchange_text:
      'Com o serviço de carteira integrado na central, você pode recarregar, comprar e vender moedas em qualquer central de empresas parceiras.',
    home_sec2_exchange_more: 'Saiba mais sobre cobrança de câmbio',
    home_sec2_mobile_pay: 'Obter pagamentos móveis',
    home_sec2_mobile_text:
      'As soluções são automaticamente otimizadas para celular. Obter mundo onde ainda mais fácil de pagar através do site móvel ou as aplicações Android e iOS.',
    home_sec2_mobile_more: 'Veja mais sobre pagamentos móveis',
    home_sec3_h2: 'Encontre mais trabalho com parceiros ONEWORLDPAY freelance.',
    home_sec3_global:
      'ONEWORLDPAY vai ligar as oportunidades mais globais com os principais sites independentes do mundo.',
    home_sec3_btn: 'Verificando ONEWORLDPAY para freelance',
    home_sec4_h2: 'É fácil começar.',
    home_sec4_banner1:
      'Saiba tudo o que você precisa para começar a partir de centro de negócios ONEWORLDPAY.',
    home_sec4_banner2:
      'Junte-se à conta de negócios e verificar o seu endereço de e-mail',
    home_sec4_banner3: 'Certificado para a conta bancária',
    home_sec4_banner4: 'Selecione uma solução de pagamento',
    home_sec5_h2:
      'Por que o mundo muitas operadoras fazem ONEWORLDPAY confiança.',
    home_sec5_sub_text:
      'Porque é uma excelente escolha. ONEWORLDPAY você gostaria de conectar o vendedor com 25 chamadas para o cliente pelo menos dois cem milhões de pessoas em mais de 200 mercados em todo o mundo.',
    home_sec5_h3: 'Segurança.',
    home_sec5_h3_sub1:
      'determinar automaticamente scam, transações monitoramento 24 horas e o programa de proteção vendedor e comprador para proteger o seu negócio e seus clientes.',
    home_sec5_h3_more: 'Veja mais sobre o pagamento on-line',
    home_sec5_h31: 'O mundo usa.',
    home_sec5_h31_sub1:
      'Em todo o mundo, sem a necessidade de digitar as informações cada vez que fizer um pagamento rapidamente. Em 203 mercados em 26 moedas você pode pagar via cartão de crédito, cartão de débito ou ONEWORLDPAY.',
    home_sec5_h31_more: 'Veja mais sobre faturas de e-mail',
    home_sec5_h32: 'Rápido.',
    home_sec5_h32_sub1:
      'Na maioria dos casos, quando um pagamento do cliente é imediatamente creditado na sua conta ONEWORLDPAY. banco debitado ou um pagamento para o fornecedor ou o uso livremente em qualquer lugar onde o pagamento ONEWORLDPAY possível.',
    home_sec5_h32_more: 'Veja mais sobre eBay venda',
    home_sec6_h2: 'estrutura de taxas simples',
    home_sec6_sub:
      'ONEWORLDPAY irá cobrar uma taxa somente quando as vendas feitas. taxas ONEWORLDPAY são corrigidos com base na localização do cliente e da quantidade de vendas.',
    home_sec6_more: 'Veja mais sobre taxas',
    home_sec7_h2: 'Comunidade para a Coreia do Sul venda, LAB CBT',
    home_sec7_text1:
      'Instituto comércio transfronteiriço (CBT LAB) é uma comunidade comerciante ONEWORLDPAY Coreia (Coreia do ONEWORLDPAY) patrocinado para o exterior e-commerce habilitado.',
    home_sec7_text2:
      'CBT LAB está ajudando o negócio crescer compartilhar informações globalmente Costa Leste, como as últimas tendências, dicas e melhores práticas.',
    home_sec7_more: 'Saiba como tirar proveito da CBT LAB',
    home_sec8_h2: 'Conheça os parceiros interligados ONEWORLDPAY.',
    home_sec8_text1: 'Precisa de ajuda profissional para o seu negócio online?',
    home_sec8_text2:
      'Soluções de hospedagem web, carrinho de compras, soluções de comércio eletrônico, tais como obras de avanço ONEWORLDPAY um parceiro comprou esta ajuda o seu negócio.',
    home_sec8_text3:
      'Encontrar ONEWORLDPAY um parceiro para o meu negócio agora.',
    home_sec8_more: 'mais Partners',
    home_sec9_h2: 'Torne-se um vendedor global. Isto irá ONEWORLDPAY juntos.',
    home_sec9_btn: 'Inscreva-se para uma conta agora',
    home_learn_h2: 'Saiba mais',
    home_learn_li1: 'Solução Web Pagamento',
    home_learn_li1_1: 'Website Payments Standard',
    home_learn_li1_2: 'ONEWORLDPAY Caixa',
    home_learn_li1_3: 'Comprar no eBay',
    home_learn_li1_4: 'Soluções comparar',
    home_learn_li2: 'outros pagamentos',
    home_learn_li2_1: 'faturas de e-mail ONEWORLDPAY',
    home_learn_li2_2: 'mobile Commerce',
    home_learn_li2_3: 'Negócios para pagamentos automáticos',
    home_learn_li2_4: 'ONEWORLDPAY para B2B',
    home_learn_li2_5: 'ONEWORLDPAY para freelance',
    home_learn_li3: 'configuração e integração ONEWORLDPAY',
    home_learn_li3_1: 'centro de negócios ONEWORLDPAY',
    home_learn_li3_2: 'ONEWORLDPAY Coreia comunidade comerciante (CBT LAB)',
    home_learn_li3_3: 'Adicionar ONEWORLDPAY ONEWORLDPAY ao site',
    home_learn_li3_4: 'Confira Melhor Guia Set',
    home_learn_li3_5: 'revelador',
    home_learn_li3_6: 'parceiro',
    home_learn_li3_7: 'como ONEWORLDPAY',
    home_learn_li4: 'Gerenciar Minha Conta',
    home_learn_li4_1: 'aplicativos de negócios ONEWORLDPAY',
    home_learn_li4_2: 'Configurações da conta de negócios',
    home_learn_li4_3: 'Programa de proteção ao vendedor',
    home_learn_li4_4: 'Gerir reclamações de clientes',
    home_learn_li4_5: 'Chargebacks Entendimento (Chargeback)',
    home_learn_li4_6: 'restrições de conta Compreensão',
    home_learn_li4_7: 'Dicas de Prevenção de Fraude',
    home_learn_li4_8: 'PCI Compliance',
  },
  pay_nav: {
    view_your_account: 'Ver toda a sua conta',
    account_summary_views: 'Resumo da conta Visualizações',
  },
  pay_login: {
    secure_sub_title: 'Login e Segurança',
    secure_my_profile: 'meu perfil',
    secure_update_complete:
      'O perfil e as configurações ambiental foram atualizados.',
    secrue_suggest: 'Sempre que você nos contar a sua experiência.',
    search: 'recuperação',
    my_info: 'Informações pessoais',
    update: 'atualizar',
    e_mail: 'E-mail',
    default: 'informação básica',
    call: 'telefone',
    phone: '(Móvel)',
    pay_mobile: 'mobile Payment',
    trading: 'Troca de idéias',
    password: 'senha',
    change: 'mudança',
    secure_qa: 'Pergunta de segurança',
    staying: 'Mantenha-me conectado para compras mais rápidas',
    edit: 'compilação',
    browse_manage:
      'Gerenciar o dispositivo selecionado eo navegador para manter o estado de login.',
    account_type: 'Tipos de conta',
    account_delete: 'conta Cancelamento',
    business: 'negócio',
    edit_email: 'Editar endereço de email',
    change_email: 'Mudança de Endereço de Email',
    update_email: 'Adicione o seu e-mail',
    eamil_url: 'E-mail',
    update_email_url: 'Adicione o seu endereço de e-mail',
    error_email: 'Desculpe. O padrão de e-mail não pode ser editado.',
    confirm_new_email: 'Verificar novo endereço de e-mail',
    change_mail: 'Alterar e-mail',
    confirm: 'confirmação',
    changing: 'mudança',
    deleting: 'eliminação',
    reaming:
      'Atualmente dois do endereço de email associado à sua conta. Você pode adicionar mais de 5 e-mail.',
    qa_1: 'Qual é o nome da escola participou pela primeira vez?',
    qa_2: 'Qual é o nome do primeiro animal de estimação?',
    edit_phone: 'Editar um número de telefone existente',
    korea: 'República da Coreia',
    explanation:
      'Ao adicionar o número, eu confirmar que concorda para discar automaticamente e receber chamadas pré-gravados e texto, dependendo do motivo para a autoridade para adicionar dois números estão descritos na Política de Privacidade. taxas normais podem ser aplicadas.',
    edit_phone_num: 'número de telefone Alterar',
    edit_password: 'Change Password',
    confirm_password: 'Verifique a sua senha atual',
    new_passod: 'nova senha',
    confirm_password_new: 'Confirmar Nova Senha',
    secure_question: 'Pergunta de segurança',
    secure_pick: 'perguntas de escolha',
    secure_answer: 'resposta',
    edit_browse:
      'Com ONEWORLDPAY One Touch você pode rapidamente completar o pagamento sem ter que logar-se cada vez.',
    already_log: 'O logado na máquina.',
    off_all: 'ONEWORLDPAY One Touch off em todos os seus dispositivos',
    support:
      'PayPal está comprometida com a satisfação do cliente 100%. Se você tem um problema com sua conta',
    support_center: 'Suporte ao cliente',
    support_text1: 'Ou verificar o',
    support_text2: 'Por favor, consulte.',
    support_warn:
      'Se você cancelar a sua conta, você não pode cancelar seus registros de contas também irá desaparecer e níveis de confiabilidade.',
  },
  help: {
    support_center: 'apoio',
    resolution_center: 'Resolução de Conflitos Centro',
    qa_search: 'Pesquisar Perguntas Frequentes',
    common_qa: 'questões gerais',
    common_qa_1:
      'O `Por que é uma mensagem de erro é exibida após a atualização do status do seu pedido através dos obter fundos links?',
    common_qa_2:
      'Como faço para retirar fundos da conta Coreia do ONEWORLDPAY?',
    common_qa_3:
      'Como faço para adicionar um cartão de débito ou cartão de crédito à minha conta ONEWORLDPAY?',
    common_qa_4:
      'ONEWORLDPAY Esqueci minha senha da conta. Como faço para redefinir minha senha?',
    common_qa_5: 'Posso já cancelar enviou pagamento montante ONEWORLDPAY?',
    common_qa_6: 'Como faço para receber pagamentos através ONEWORLDPAY?',
    common_qa_7: 'Como faço para enviar o pagamento via ONEWORLDPAY?',
    common_qa_8:
      'Como faço para adicionar uma conta bancária para a conta ONEWORLDPAY?',
    common_qa_9:
      'Como posso verificar a conta bancária associada à minha conta ONEWORLDPAY?',
    common_qa_10: 'Como faço para desativar o limite de conta ONEWORLDPAY?',
    technical_support: 'Inscrever-se para questões técnicas e atualizações.',
    condition_cocopay: 'estado de exibição ONEWORLDPAY',
    muliple_help: 'Mais maneiras de obter ajuda',
    trading_help: 'Para resolver tais problemas negócio',
    tex_center: 'Centro de imposto',
    tex_help: 'Encontrar formas de impostos e outros recursos',
    need_help: 'Fale conosco',
    help_center: 'Fale com o Suporte ao Cliente',
    help_to_center: 'Fale com o Suporte ao Cliente',
    prepare: 'Em breve.',
    fast_help:
      'Conte-nos o seu problema para que possamos mais rapidamente ajuda ONEWORLDPAY.',
    my_search: 'Procurar meu problema',
    common_problem: 'Problemas comuns',
    login_problem: 'problemas de login',
    unkown_charge: 'acesso não autorizado ou dívidas desconhecidas relatório',
    send_money: 'Enviar dinheiro',
    get_fund: 'receber dinheiro',
    withdraw_money: 'retirar dinheiro',
    pay_cancel: 'Pagamento ou cancelar ordem',
    pay_hold: 'Pagamento pendente ou à espera',
    refund: 'reembolsos',
    pre_pament: 'pagamentos pré-aprovados',
    negative_balance: 'saldo negativo',
    account_qa_1:
      'ONEWORLDPAY retirar minha conta o estado que ele mostra como "concluída" Por que é dinheiro que não contém uma conta bancária?',
    account_qa_2:
      'Qual é a razão da minha ONEWORLDPAY retirada ainda é um status "pendente"?',
    account_qa_3: 'Por que a minha retirada pendente?',
    item_title: 'Senha de acesso e Conta',
    item_title_2: 'Conta Perfil & Definições',
  },
  business: {
    no_trade: 'Não há mercados de câmbio possíveis.',
    view_your_account: 'Ver toda a sua conta',
    available: 'disponível',
    calculate_late:
      'montante com base na taxa de câmbio recentemente estimada.',
    payment_transfe: 'As transferências de pagamento',
    exchange: 'câmbio',
    currency_update: 'Incluir chamada',
    update_btn: 'botão de adição',
    currency_cal: 'conversor de moeda',
    pay_default: 'Preferências de pagamento',
    payment_send: 'Enviar ou pedido de pagamento',
    account_list: 'Lista de contas',
    no_alias: 'não há aliases',
    new_bank: 'Conecte o novo banco',
    card: 'cartão',
    new_card: 'Conecte o novo cartão',
    credit: 'crédito',
    preference_payment:
      'Escolha os seus métodos de pagamento online preferenciais.',
    payment_tip:
      'Ao fazer compras on-line ou enviar o pagamento de bens e serviços que utilizam este meio. Você pode a qualquer momento escolher um método de pagamento diferente durante o checkout.',
    payment_more: 'Aprender sobre suas preferências de pagamento',
    paymnet_changes: 'equilíbrio ONEWORLDPAY',
    debit_card: 'Cartão de débito',
    currency_tip:
      'Se você adicionar uma moeda, todos os pagamentos futuros recebidos nessa moeda serão creditados aos fundos apropriados. A moeda base é usado para enviar um pagamento de pagamento ou solicitação.',
    currency_1: 'dólar australiano',
    currency_2: 'Franco suíço',
    currency_3: 'Coroa checa',
    currency_4: 'Coroa dinamarquesa',
    currency_5: 'euro',
    currency_6: 'libra inglesa',
    currency_7: 'Dólar de Hong Kong',
    currency_8: 'Forint',
    currency_9: 'Novo shekel israelense',
    currency_10: 'Peso mexicano',
    currency_11: 'Noruega Krone',
    currency_12: 'Dólar da Nova Zelândia',
    currency_13: 'Peso filipino',
    currency_14: 'Zloty polonês',
    currency_15: 'Rublo russo',
    currency_16: 'Coroa sueca',
    currency_17: 'Dólar de Singapura',
    currency_18: 'baht',
    currency_19: 'New dólares de Taiwan',
    withdraw_account: 'Conta retirada',
    exchanged: 'Depois de câmbio',
    exchange_rate: 'Taxas de câmbio',
    exchange_tip:
      'A taxa de câmbio é um valor estimado com base na taxa de câmbio atual, a taxa de câmbio está incluído no ONEWORLDPAY.',
    currency_default: '(A) O iene japonês está definido para a moeda padrão.',
    currency_default_notice:
      'A moeda base é usado para enviar um pagamento de pagamento ou solicitação.',
    currency_default_notice2:
      'Fechando a chamada não é exibido sobre o saldo não recebe qualquer pagamento à chamada.',
    currency_default2: 'JPY (s), o padrão',
    currency_quit_jp_btn: 'Fechar Dólares',
    currency_quit_btn: 'Close call',
    bank_account: 'contas',
    bank_account_create_day: 'Gaeseolil',
    bank_account_change: 'saldos',
    bank_account_check: 'confirmando Banco',
    bank_account_remove: 'Excluir Banco',
    bank_continue: 'Você gostaria de continuar?',
    bank_tip:
      'Pendentes transações com os bancos são processados ​​após a exclusão.',
    bank_this_delete: 'Excluir Banco',
    card_tip:
      'A conta ONEWORLDPAY quiser usá-lo sem gastar ou limites de retirada?',
    card_confirm: 'Verifique o cartão.',
    card_type: 'tipo',
    expiry_date: 'expiração',
    card_adress: 'Endereço de Cobrança',
    card_update: 'cartão de Atualização',
    card_delete: 'cartão de exclusão',
    card_this_delete: 'cartão de exclusão',
    card_tip2:
      'Este método de pagamento é actualmente preferido. Após a conclusão, você pode definir um método preferido de pagamento diferente. Negócio está pendente com (um) indeterminado é tratado após a eliminação.',
    secure_code: 'Código de segurança',
  },
  shop: {
    shop_list: 'loja Lista',
    shop_create: 'Loja criado',
    shop_cre_date: 'adicionado',
    shop_title: 'Nome da loja',
    shop_id: 'Código da loja',
    shop_state: 'estado',
    shop_work: 'trabalho',
    shop_detail: 'mais',
    shop_retouch: 'cristal',
    shop_settlement: 'Liquidação lista de contas',
    shop_history: 'transações',
    no_shop_history: 'Não há histórico de transações.',
    no_shop_list: 'Não há lista de lojas',
  },
  merchant: {
    create: 'loja inscrição',
    update: 'inscrição',
    retouch: 'lojas modificado',
  },
  pay_legal: {
    service_usage: 'ONEWORLDPAY Termos de serviço',
    detail_usage:
      'Estes Termos e Condições será aplicada para a Ásia-Pacífico, América Latina e alguns países da Europa, Oriente Médio e utilizadores africanos. Para ver os termos e condições para diferentes países ou regiões, escolha da lista abaixo.',
    nation: 'Selecione um país',
    every_consumer: 'Todos os usuários',
    service_agree: 'O seu contrato para a ONEWORLDPAY Serviço',
    privacy_state: 'política de Privacidade',
    purpose_policy: 'ONEWORLDPAY Política de Uso',
    payment_agreement: 'ONEWORLDPAY acordo método de pagamento alternativo',
    sell_buy: 'Merchant e Negócios',
    shop_policy: 'Políticas ONEWORLDPAY Suporte Loja',
    contract_profit: 'Contrato de empresa com fins lucrativos',
    billing_agreement: 'Contrato de faturamento',
    direct_debit_agreement: 'fundos ONEWORLDPAY recebidos e acordos de débito',
    additional_info: 'Informações adicionais',
    infringement: 'Somyeongseo violações de políticas',
    policy_update: 'Atualizações política',
    warn1:
      'Notificar os consumidores: serviço de pagamento ONEWORLDPAY é considerado como um meio pré-pagos de pagamento (valor armazenado Facility) de acordo com a lei australiana.',
    warn2:
      'ONEWORLDPAY os proprietários dos meios pré-pagos de pagamento ⓒ ONEWORLDPAY All rights reserved não requer a aprovação da Autoridade de Supervisão Financeira da Austrália. Nós também incentivar os consumidores (usuários) são lidas atentamente estes Termos e Condições.',
    warn3:
      'Estes Termos de Uso e Avisos fornecer os termos e condições associados a um determinado serviços ONEWORLDPAY.',
  },
  pay_privacy: {
    effective_day: 'Data de Vigência: 28 de março, 2019',
    summary: 'resumo',
    personal_data: 'Os dados pessoais recolhidos pela ONEWORLDPAY',
    personal_date_cause: 'Razões manter seu ONEWORLDPAY dados pessoais',
    summary_1: 'Nossos usuários são',
    summary_2: 'Sites',
    summary_3: 'ou visita',
    summary_4: 'serviço',
    summary_5: 'Ao usar do usuário',
    summary_6: 'Os dados pessoais',
    summary_7:
      'Como coletar e armazenar, gerenciar e compartilhar, explicando que a transferência preparou esta Política de Privacidade. Esta Política de Privacidade aplica-se a seus dados pessoais quando visita o nosso site ou usar o serviço, outra ONEWORLDPAY',
    summary_8: 'usuário',
    summary_9:
      'Ela não se aplica a sites ou ONEWORLDPAY web on-line não são de propriedade ou ajustes, incluindo local de serviço ou serviço.',
    summary2_1:
      'ONEWORLDPAY você pode visitar nossos sites ou coletar informações pessoais quando você usa os seguintes tipos de serviços.',
    summary2_2: 'Use cima e Informação',
    summary2_3:
      'Quando você se inscrever uma conta para usar os serviços de ONEWORLDPAY, para atender as informações necessárias para recolher dados pessoais, a fim de fornecer o serviço solicitado pelo usuário.',
    summary2_4:
      'Dependendo dos serviços selecionados, você pode pedir para fornecer as informações de identificação necessários para criar um nome de usuário, endereço, número de telefone, endereço de e-mail, conta.',
    summary2_5:
      'Termos que você pode pedir para fornecer dados pessoais adicionais, dependendo do serviço.',
    summary3_1: 'experiências e informações negociação',
    summary3_2:
      'Usando os serviços de ONEWORLDPAY ou se o acesso ao site, por exemplo, comprar do vendedor, ou recebimento de dinheiro ou se o processamento de um dinheiro do pagamento ou enviar para amigos e familiares, recolher outras informações relacionadas negociação, bem como informações sobre a transação de ONEWORLDPAY a. Outras informações trade-relacionada inclui o envio ou solicitar dinheiro, bens ou serviços de pagamento dinheiro, o vendedor, incluindo informações sobre todos os métodos de pagamento usados ​​para completar as informações informações de transação e dispositivo, os dados de tecnologia, informações de localização, e similares.',
    summary4_1: 'Informações do participante',
    summary4_2:
      'Quando você usa ou o acesso ao serviço local ONEWORLDPAY recolhe dados pessoais que os usuários fornecem sobre outros participantes envolvidos no negócio.',
    summary4_3: 'Para enviar ou pedido de dinheiro',
    summary4_4:
      'Se você enviar ou solicitar dinheiro através da ONEWORLDPAY Serviço de recolher o seu nome, endereço, número de telefone, dados pessoais, como receber dinheiro de suas informações de conta financeira do participante enviar o dinheiro para você.',
    summary4_5:
      'O escopo dos dados pessoais solicitados em relação aos participantes pode variar, dependendo do serviço utilizado para enviar ou solicitar dinheiro.',
    summary5_1:
      'Pagamento por outras pessoas em vez de contas ou projeto de lei solicitando pagamento para outra pessoa',
    summary5_2:
      'Se você usar o serviço ONEWORLDPAY para pedir-lhes para pagar a conta em nome de outra pessoa, ou pagar suas contas em seu nome para outro usuário, o nome do usuário, endereço, número de telefone, endereço de email, faturamento usuário em vez de contas ou outros o proprietário da conta deve recolher dados pessoais relevantes, incluindo número da conta que você deseja pagar em seu lugar.',
    summary6_1: 'Colocar mais dinheiro na sua conta',
    summary6_1_1: 'A sua conta',
    summary6_2:
      'A fim de juntar dinheiro para outras contas na conta do usuário ou o usuário pode possuir, ou se você usar o serviço ONEWORLDPAY a solicitação para ser adicionado ao montante nesta conta para os outros usuários do outro lado do usuário para processar eficientemente o seu pedido reunir informações ou pode coletar informações sobre você do outro lado.',
    summary6_3:
      'Por exemplo, carregar ou usar a solicitação de serviços ONEWORLDPAY a ser adicionado ao valor na conta para um telefone celular, você pode coletar outras informações, incluindo dados pessoais e número de conta de celular dos outros participantes.',
    summary7_1: 'Informações relativas à pessoa em seus amigos e contatos',
    summary7_2:
      'Quando o usuário se conecta a lista de contatos em sua conta, é mais fácil dar ajudar as pessoas a lidar com quando ONEWORLDPAY com seus amigos e contatos. Assim que o usuário pode utilizar o dispositivo, ou configurar uma conexão entre plataformas ou dispositivos para contas ONEWORLDPAY ou mídias sociais de mídia social, quando conectado à plataforma melhores serviços ONEWORLDPAY coletar e usar seus contatos informações lista (nome, endereço, endereço de e-mail, etc.) em ONEWORLDPAY melhorar o ambiente.',
    summary8_1:
      'As informações que você optar por fornecer ONEWORLDPAY a fim de utilizar certos serviços online ou serviços adicionais',
    summary8_2:
      'Se o pedido ou participar da seleção do site para solicitar recursos ou serviços melhorados, ou outros recursos opcionais, você pode coletar informações adicionais sobre os usuários de ONEWORLDPAY.',
    summary8_3:
      'Se os métodos usados ​​para coletar informações a partir desses serviços diferentes daqueles declarados nesta Política de Privacidade, as informações recolhidas durante um aviso separado.',
    summary9_1:
      'Informação para o utilizador ao utilizar o serviço "ONEWORLDPAY não pagamento"',
    summary9_2:
      'Para alguns serviços limitados podem precisar entrar ou usar as configurações da conta de não-pagamento. ONEWORLDPAY irá recolher os seus dados pessoais, todos os métodos de pagamento informações do dispositivo relevante, dados de tecnologia, informações de localização necessárias para o usuário para completar a transação. Quando você seleciona o proprietário da conta eo pagamento para o não-negociação, você pode construir e informações de transação coleta associado à sua conta.',
    summary9_3:
      'Se o usuário enquanto não o dono da conta e selecione o pagamento para o negócio não ONEWORLDPAY, coletar e armazenar todas as informações que você fornece são usadas e compartilhadas de acordo com a informação nesta Política de Privacidade.',
    summary10_1: 'informações específicas do usuário obtidos de terceiros',
    summary10_2:
      'De um terceiro, como comerciante, provedores de dados, agências de crédito, na medida permitida por lei, você pode obter as informações.',
  },
  partner: {
    be_partner: 'Torne-se um parceiro de ONEWORLDPAY.',
    banner_text:
      'Compras provedor de plataforma, de mercado, há uma operadores de suporte de faturamento que necessitam de um provedor de serviços de pagamento pode ser um parceiro de ONEWORLDPAY.',
    banner_btn: 'Para entrar em contato com seu gerente de conta',
    benefit: 'benefícios ONEWORLDPAY que os parceiros têm direito',
    benefit_1: 'Integração e suporte técnico para a construção de soluções',
    benefit_2:
      'Por favor, não hesite em contactar a nossa equipe de suporte para que você possa obter ajuda na integração ONEWORLDPAY. ONEWORLDPAY portal desenvolvedor também pode ser usado como um recurso.',
    benefit_3: 'crescimento do negócio através de oportunidades de marketing',
    benefit_4:
      'Aproveitar as muitas oportunidades de comercialização previstas ONEWORLDPAY pode atrair clientes potenciais.',
    traction: 'E reboque pagamentos em todo o mundo.',
    traction1:
      'parceiros ONEWORLDPAY estão apoiando uma plataforma inovadora para uma solução suave de vendedores para ONEWORLDPAY confiança.',
    traction_btn: 'mais Partners',
    program: 'Partner Program ONEWORLDPAY é livre para participar.',
    program_1:
      'Por favor, preencha o formulário on-line, nós entraremos em contato em ONEWORLDPAY.',
    program_2:
      'Por favor, descreva as soluções de negócios operacionais e em execução.',
    program_3:
      'Por favor ONEWORLDPAY contato para discutir as mudanças necessárias.',
    program_4:
      'ONEWORLDPAY integrar e ajudar a garantir que eles recebam ONEWORLDPAY pagamento.',
    program_btn: 'Para entrar em contato com seu gerente de conta',
    common_qa: 'Perguntas Mais Frequentes',
    common_qa1: 'Existe algum parceiro fornecedores ONEWORLDPAY?',
    common_qa1_text:
      'parceiro ONEWORLDPAY é a empresa B2B (business-to-business) que oferece aos seus clientes soluções ONEWORLDPAY. ONEWORLDPAY está trabalhando com organizações como o carrinho de compras, empresas de hospedagem web, desenvolvedores web, provedores de logística e agência de marketing digital, gateway de pagamento.',
    common_qa2: 'Que parceiros ONEWORLDPAY elegíveis?',
    common_qa2_text: 'Contacte o seu gestor de conta',
    common_qa2_text_2:
      'Você pode obter aconselhamento sobre as qualificações dos parceiros.',
    common_qa3: 'Nós fornecemos serviços de apoio integrados no ONEWORLDPAY?',
    common_qa3_text:
      'Uma vez cadastrado no programa parceiro e ONEWORLDPAY aprovação para entrar, você pode acessar as valiosas documentação e desenvolvedor fóruns integrados. Também pode obter suporte integrado para consultores para o certificado.',
    common_qa4:
      'Há também um fora de negócios da Coreia, I pode se inscrever separadamente para cada país no Programa de Parceiros?',
    common_qa4_text:
      'Depende do país que você está operando um negócio. Em ONEWORLDPAY estão implantando representante do parceiro especializado para as necessidades regionais em vários países.',
    common_qa4_more: 'Ver Partner Program fornece nacional',
  },
  pay_main: {
    total_product: 'produto total',
    total_sum: 'agregado',
    pay_this_account: 'Definir esta conta como um método de pagamento.',
    bill_show:
      'As informações transação é apresentada da seguinte forma na especificação.',
    banner_text: 'ONEWORLDPAY é mais seguro',
    banner_text2: 'Um pagamento rápido.',
    banner_text3:
      'Não importa onde fazer compras irá manter suas informações financeiras seguras.',
    footer_1: 'Termos e Condições',
    footer_2: 'Contrato de usuário',
    footer_3: 'política de Privacidade',
    footer_4: 'feedback',
    footer_5:
      'Notificação aos consumidores: Perfil do Coco Banco O proprietário do pagamento pré-pago significa ⓒ Cocobank Todos os direitos reservados não requer a aprovação da Autoridade Sueca Fiscal Fiscal.',
    footer_6: 'Termos de Uso',
    footer_7: 'Também sugerimos para lê-lo com cuidado.',
    footer_8: 'faturamento',
    wallet: 'E-wallet gestão',
    last_name: 'sexo',
    card_number: 'Número do cartão',
    three_number: 'três dígitos',
    name: 'nome',
    pay_cocopay: 'Para pagar por ONEWORLDPAY',
    free_shipping:
      'Se a conta ONEWORLDPAY, você pode obter retorno livre o transporte, proteção de compra.',
    email_phone: 'E-mail ou número de telefone',
    login_error: 'Você tem assinatura problema em?',
    pay_card: 'Pagamento por cartão',
    cancel_back: 'Anular e voltar à página anterior',
  },
  site_map: {
    site_map_tip: 'Um link que irá ajudá-lo a explorar a conta ONEWORLDPAY.',
    map_fund: 'fundos',
    map_fund_1: 'Debitado',
    map_fund_2: 'Minha capacidade de utilizar o saldo é?',
    map_fund_3: 'Enviar ou pedido de dinheiro',
    map_fund_4: 'gerenciamento de chamadas',
    map_fund_5: 'ONEWORLDPAY meus descontos de cartão de débito',
    map_fund_6: 'Obter cartão de débito ONEWORLDPAY',
    map_fund_7: 'Programação de cobrança ONEWORLDPAY crédito',
    map_deal: 'acordo',
    map_deal_1: 'Ver todas as atividades de negócios',
    map_deal_2: 'visualizações actividades (incluindo equilíbrio e taxas)',
    map_deal_3: 'gráficos e tabelas Ver oferta',
    map_deal_4: 'Baixar negócio',
    map_deal_5: 'Em resposta a um pedido ou estorno',
    map_deal_6: 'IPN (notificação de pagamento instantâneo) História',
    map_profile: 'Meu perfil e configurações',
    map_profile_1: 'espelho de negócios',
    map_profile_2: 'E-mail, endereço, telefone ou atualização de senha',
    map_profile_3: 'conta bancária ou cartão de atualização',
    map_profile_4: 'Notificações de Atualizações',
    map_profile_5: 'Limites Ver Conta',
    map_profile_6: 'Gerenciamento de usuários',
    map_profile_7: 'Preferências Entrega Atualizar',
    map_support: 'apoio',
    map_support_1: 'Ir para o Centro de Resolução de Conflitos',
    map_support_2: 'Ir para Centro de Suporte',
    map_support_3: 'Fale conosco',
    map_support_4: 'informações taxa comerciante ONEWORLDPAY',
    map_report: 'relatório',
    map_report_1: 'Relatório de configurar, gerenciar ou fazer o download',
    map_manage: 'ferramentas',
    map_manage_1: 'Ver ferramenta',
    map_manage_2: 'gestão botão ONEWORLDPAY',
    map_manage_3: 'Gestão pagamento regular',
    map_consum: 'cliente',
    map_consum_1: 'Ver lista de convidados',
  },
  fee: {
    fee_tip: 'Simples Estrutura Fee',
    fee_banner_1:
      'Geralmente, a compra é livre e podem estar sujeitos a taxas de câmbio.',
    fee_banner_2:
      'Se as vendas não ficar com as taxas mensais ONEWORLDPAY, ou taxas de cancelamento. Depois de cada comissão só será pago.',
    fee_h2: 'Normalmente compra é livre.',
    fee_text1:
      'As taxas para processamento de pagamentos são pagos pelo vendedor.',
    fee_text2: 'No entanto, você pode trocar taxa é aplicada.',
    fee_more: 'taxas do vendedor saber mais',
    fee_text3:
      'À venda pelo site da factura ou pagamento E-mail (de pagamento internacional taxas normais)',
    fee_text4: 'A taxa fixa com base no recebimento de chamadas',
    fee_text5: 'taxas de câmbio podem ser aplicadas adicionalmente.',
    fee_text6:
      'Por exemplo, para um recibo de pagamento da taxa fixa em dólares é de US $ 0,30 USD.',
  },
  dash: {
    more: 'mais',
    withdraw_asset: 'retirada de fundos',
    currency: 'moeda',
    quotes: 'Recibos e Orçamentos',
    last_6_months: 'Últimos 6 meses',
    make_invoice: 'geração de fatura',
    manage_invoice: 'invoice Management',
    grown_up: 'Por favor, envie a crescer o negócio para uma cotação.',
    un_paid_invocie: 'faturas pendentes',
    make_quotes: 'geração Citação',
    quotes_1: 'Um sugeriu quaisquer facturas pendentes.',
    quotes_2: 'ONEWORLDPAY factura',
    quotes_alarm: 'lembretes de envio',
    quotes_detail: 'Mostrar mais',
    quotes_who: 'Bill: Choi, So - Jovem',
    latest_act: 'Atividade recente',
    act: 'atividade',
    received: 'Pagamento recebido',
    send: 'De Pagamento',
    act_record: 'Atividade (incluindo equilíbrio e taxas)',
    pay_person: 'pessoas biller',
    show_all: 'Ver tudo',
    tell_us: 'Por favor, diga-nos a sua opinião.',
    feed_text:
      'Por favor, tome um momento para nos dizer a sua opinião sobre a informação do mostrador recentemente concebido nesta página. Obrigado!',
    service: 'fornecer feedback',
    feed_text_back:
      'Obrigado por seus comentários! Foi assim que nosso site é útil?',
    feed_placeholder:
      'Por favor, deixe-me saber a razão pela qual eu vim hoje ONEWORLDPAY há uma maneira melhor. Não inclua informações pessoais, tais como e-mail ou número de conta.',
    feed_p:
      'pessoal do escritório ONEWORLDPAY e os hóspedes aos seus comentários podem ser enviados internamente, para que possa vê-lo, não deixe qualquer informação pessoal. serviços ao cliente, por favor clique aqui. de ONEWORLDPAY',
    feed_protect: 'política de Privacidade',
    feed_law: 'Condições legais',
    feed_or: 'e',
    feed_need: 'ver',
    trade_name: 'nome de negócio',
    trade_id: 'ID negócio',
    transaction_type: 'negócio Tipo',
    trade_amount: 'pagamento',
    detail_show: 'Olhe',
  },
  shop_detail: {
    detail_info: 'Detalhes loja',
    api_signature: 'Armazenamento de chaves de assinatura',
    msg_shop_create: 'Esta loja foi registrado.',
    msg_shop_modify: 'Esta loja foi corrigido.',
  },
  merchant_account: {
    create_account: 'Gerar Conta de Liquidação',
    enroll_account: 'Conta de Liquidação de Registro',
    pls_select_account: 'Escolha Conta de Liquidação',
  },
  transaction_detail: {
    select_pay_account: 'Selecione a conta de pagamento',
    transaction_title: 'detalhes das ofertas',
    order_id: 'Loja Número de Pedido',
    pay_account_title: 'Pagamento Nome da conta',
    pay_account_number: 'Pagamento Número de Conta',
    pay_account_balance: 'O pagamento do saldo da conta',
  },
  guide: {
    title: 'guia comercial C2C',
    watch_video: 'Ver as imagens',
  },
  account_transfer: {
    transfer: 'Transferência de conta',
    transfer_list: 'histórico de transferências',
    msg_required_data: 'Por favor, indique todos os valores',
    msg_not_select_withdraw_account:
      'Por favor, selecione a conta de pagamento',
    create_transfer_title: 'Transferência de conta',
    from_account_select: 'Selecionar conta de pagamento',
    available_transfer: 'quantidades de transferência',
    to_account_input: 'Transferência de entrada do número de conta',
    to_account_confirm: 'Transferência de Verificação de Conta',
    to_account_user_name: 'Transferência de conta Nome de Membro',
    transfer_amount: 'transferência de Valor',
    delete_amount: 'correção',
    all_amount: 'CHEIA',
    description: 'explicação',
    transfer_btn: 'transferências',
    transfer_btn_2: 'transferências',
    transfer_info_check: 'Verificação de informações pedido de transferência',
    transfer_info_check_2: 'Verificação de informações pedido de transferência',
    from_account_number: 'Retirada Número de Conta',
    from_asset_title: 'Ativos Conta de abstinência',
    to_account_number: 'Transferir Número de Conta',
    success_transfer: 'Transferência foi processado com êxito.',
    success_withdraw: 'A retirada foi processada com sucesso.',
    transfer_list_detail: 'Transferir History &',
    search_transfer_asset: 'Busca por imóvel',
    search_transfer_account: 'Busca por conta',
    reset: 'inicialização',
    search: 'recuperação',
    transfer_list_detail_tit: 'Transferir Detalhes Detalhes',
    no_transfer: 'Não há detalhes de transferência',
    msg_not_search_account:
      'número de conta não existe ou não é uma entrada válida.',
    my_account_transfer: 'transferências A minha conta',
    msg_pls_select_account: 'Depois de selecionar um ativo, pesquise na conta.',
    placeholder_amount: 'Por favor, indique o montante da transferência',
    not_search_user_name: 'Não tenho certeza nome de usuário',
    msg_select_asset_search: 'Por favor selecione uma conta',
    success_fail: 'A transferência não foi bem sucedida.',
    pls_search_asset: 'Pesquise ativos.',
    pls_search_account: 'Pesquise na sua conta.',
    pls_select_asset: 'Por favor, selecione um ativo.',
    select_account_first: 'Selecione uma conta primeiro.',
    select_market_first: 'Selecione o mercado primeiro',
    not_exist_account: 'A conta do ativo não existe.',
    favorites: 'Favoritos',
    no_inquiry_history: 'Não há histórico de perguntas.',
    from_user_name: 'Membros da conta em atraso',
  },
  bank_service_center: {
    title: 'assunto',
    date: 'data',
    state: 'estado',
    enter_search_word: 'Digite os termos de pesquisa',
    list: 'lista',
  },
  service_center: {
    view_all: 'Ver Todos',
    contact_history: 'Histórico de inquérito',
    privacy_Statement: 'Política de manipulação de informações pessoais',
    would_you_agree: 'Deseja concordar com o exposto acima?',
    mobile_number: 'Número de telemóvel',
    target_of_inquiry: 'Assunto do inquérito',
    inquiry_contents: 'Conteúdos de investigação',
    please_enter_your_inquiry: 'Digite sua pergunta.',
    send: 'Enviar',
    normal_inquiries_received: 'Sua pergunta foi recebida com sucesso.',
    inquiry_history: 'Histórico de inquérito',
    pls_select_inquiry_type: 'Selecione o tipo de contato',
    pls_login_to_use_inquiry: '1, Entrar no as primeiras investigações.',
    non_member_login: 'Login não associado',
    contact_id: 'Contact ID',
    view_inquiry: 'Ver contato',
    service_center: 'atendimento ao cliente',
    inquiry_details: 'Detalhes de contato',
    msg_enter_title: 'Por favor insira um título.',
    msg_enter_your_content: 'Por favor digite suas informações.',
    msg_pls_login: 'Por favor login.',
    go_back: 'Volte',
    re_contact: 'material de contato',
    contents: 'conteúdo',
    msg_no_inquiry_history: 'Não há detalhes de contato.',
    msg_require_login_additional_authentication:
      'Você precisa estar logado ou autenticação adicional.',
    when_you_member: 'Quando um membro',
    msg_inquiry_history_can_view_after_login:
      'Os membros dos detalhes de contato podem ser vistos após o login.',
    non_member: 'Quando não-membros',
    lookup_inquiry: 'Fale Lookup',
    msg_enter_inquiry_id: 'Digite o ID do contato.',
    msg_enter_password_when_registering_your_inquiry:
      'Por favor, digite a senha que você definiu quando você chama registo.',
    frequently_asked_questions: 'Perguntas Mais Frequentes',
    msg_enter_your_password: 'Por favor insira sua senha.',
  },
  modal: {
    not_seeing_day: 'Não visto durante o dia',
  },
  login_guide_modal: {
    title: 'Informação',
    sub_title:
      'O sistema de login será renovado para que os membros usem a troca sem problemas.',
    content:
      '[Antes da mudança] <br/> Login de ID criado quando você se inscreve pela primeira vez <br/><br/> [Depois da mudança] <br/> Mude para o seu número de telefone atual ou login por email. <br/> <br/> Para efetuar login até que o sistema de login seja reorganizado, faça login com o ID que você criou quando se inscreveu pela primeira vez.',
  },
  affiliate: {
    affiliate_occur_list: 'Histórico de Provisão',
    affiliate_adjust_list: 'Detalhes da liquidação de provisão',
    allowance_balance_asset: 'Saldo de provisão por ativo',
    list_allowance_balance_asset: 'Lista de saldo de provisão por ativo',
    search_by_asset: 'Pesquisa por ativo',
    allowance_search: 'Pesquisa de permissão',
    generator: 'Gerador',
    beneficiary: 'Beneficiário',
    benefactor: 'Benfeitor',
    behavior_type: 'Tipo de comportamento',
    target_unique_number: 'Segmentar número único',
    date_of_occurrence: 'Data de ocorrência',
    application_policy_name: 'Nome da política do aplicativo',
    beneficiary_type: 'Tipo de beneficiário',
    benefactor_type: 'Tipo de beneficiário',
    target_amount: 'Valor alvo',
    principal_amount: 'Quantia principal',
    allowance: 'Pagamento extra',
    allowance_assets: 'Ativos de provisão',
    allowance_amount: 'Montante da provisão',
    affiliate_log: 'Composição da provisão',
    allowance_settlement: 'Liquidação de provisões',
    allowance_settlement_info: 'Informações sobre liquidação de provisões',
    name_asset_settled: 'Nome dos ativos a serem liquidados',
    balance_receive_payment: 'Saldo a ser pago',
    select_account_settled: 'Selecionar conta a ser liquidada',
    no_affiliate_log: 'Não há subsídio incorrido.',
    no_affiliate_balance: 'Não há lista de saldos de provisão por ativo.',
    no_affiliate_adjust: 'Não há histórico de pagamentos de provisões.',
    asset_name: 'Nome do ativo',
    asset_code: 'Código do ativo',
    balance: 'Saldo',
    cumulative_amount: 'Montante acumulado',
    please_select_account: 'Por favor selecione uma conta',
    calculate: 'calcular',
    settle: 'Resolver',
    calculate_amount: 'Montante da liquidação',
    account_number: 'Número da conta',
    registration_date: 'Data de registro',
    number: 'número',
  },
  Coin_name: 'Nome da moeda',
  main_function: 'Função principal',
  disclosure_ing: 'No decurso do',
  market_balance_transfer: 'Transferência de saldo',
  available_after_login: 'Disponível após o login.',
  fast_stable_deal: 'Juntos em um negócio rápido e estável',
  cryptocurrency_exchange: 'Criptomoeda Troca',
  go_transaction: 'Ir Transacção',
  create_an_account: 'Criar uma conta',
  more_than_that: 'Mais que isso',
  vision_title: 'Visão baseada na confiança',
  vision_text1:
    'CONEWORLDPAY usa tecnologia blockchain em um novo ecossistema de ativos digitais.',
  vision_text2:
    'Ele fornece uma solução completa para integração com as redes de pagamento existentes.',
  fee_title: 'Benefícios da taxa',
  fee_text1:
    'Isenção de taxa de criação de conta, isenção de taxa de manutenção de conta,',
  fee_text2: 'Isenção de taxas de compra / venda',
  row_title: 'Barreira baixa para entrada',
  row_text1: 'Bitcoin, Ethereum, etc.',
  row_text2: 'Você pode negociar.',
  easy_title: 'Interface confortável',
  easy_text1:
    'Uma transação simples que até mesmo iniciantes podem negociar facilmente',
  easy_text2: 'Interface.',
  full_time: 'Transação em tempo integral',
  full_time_text1:
    'A qualquer hora, em qualquer lugar, 24 horas por dia, 365 dias por ano, se você tiver um telefone celular e computador',
  full_time_text2: 'A transação é possível',
  easy_sellbuy: 'Transação conveniente a qualquer hora, em qualquer lugar',
  so_easy: 'Fácil e confortável',
  b2c_mobile: 'Aplicativo móvel B2C',
  app_sellbuy:
    'Quando você faz transações com um dispositivo móvel por meio do aplicativo',
  anywhere_use:
    'Você pode fazer isso com o B2C a qualquer hora, em qualquer lugar.',
  now_start_buy: 'Comece a negociar agora.',

  procedure:
    'Ao efetuar login após acessar ONEWORLDPAY.COM/COCOBNK.COM, o processo de aprovação para compartilhamento de informações está em andamento, sendo este processo um procedimento obrigatório para o login do SNS (login social). Se o procedimento de login pelo SNS não for executado, você não poderá fazer login no ONEWORLDPAY / COCOBNK, e este procedimento é realizado de acordo com a Lei de Redes de Informação e Comunicação e a Lei de Proteção de Informações Pessoais.',
  snslink: 'Login solicitado no status de vinculação de conta SNS é',
  four_one:
    "Artigo 4.º ① O Ministro da Ciência, Tecnologia e Comunicação ou a Comissão de Comunicações da Coreia estabelece a base para a sociedade da informação através da promoção do uso de redes de informação e comunicação, gestão estável e proteção de usuários (doravante denominada 'promoção de redes de informação e comunicação e proteção de informação'). As medidas devem ser preparadas para fazer isso.",
  four_two:
    '② A política de acordo com o parágrafo 1 incluirá os seguintes assuntos.  ',
  eight:
    '8. Melhoria da segurança e confiabilidade das redes de informação e comunicação',
  nine:
    '9. Outros assuntos necessários para a promoção do uso da rede de informação e comunicação e proteção da informação, etc.',
  execution: 'Está sendo implementado de acordo com suas disposições.',
  privacy: 'Além disso, a lei de proteção de informações pessoais',
  twentyfour_three:
    'Artigo 24 (Restrição ao processamento de informações de identificação exclusiva) ③ Quando um controlador de informações pessoais processa informações de identificação exclusiva de acordo com cada um dos subparágrafos do parágrafo 1, as informações identificadas de forma exclusiva não são perdidas ⠂ furto ⠂ vazado ⠂ falsificado ⠂ adulterado ou danificado. As medidas necessárias para garantir a segurança, como a criptografia, devem ser tomadas conforme prescrito pelo Decreto Presidencial.',
  twentyfour_two:
    'Artigo 24-2 (Restrições ao processamento de números de registro de residentes) ② Os controladores de informações pessoais devem manter seus números de registro de residentes seguros por meio de medidas de criptografia para que não sejam perdidos, roubados, vazados, forjados, alterados ou danificados, apesar do Artigo 24 (3). Nesse caso, as questões necessárias relativas ao assunto da aplicação de criptografia e tempo de aplicação para cada assunto serão determinados por Decreto Presidencial, levando em consideração a escala de processamento de informações pessoais e o impacto do vazamento.',
  implemented: 'Está sendo implementado de acordo com suas disposições.',
  we_future: 'nosso futuro',
  pop_cocobank: 'COCO BANK',
  fourth_industry: 'Líder na quarta indústria',
  oc_15: '15 de outubro',
  officially_open: 'Oficialmente aberto!',
  head_branch_office:
    'Sede na Coreia (Filial Jamsil) / 1ª Filial (Filial Sinsa)',
  sep_15: '15 de setembro às 17h',
  open_popup: 'Abrir',
  thanks_for: 'Obrigado pelo seu encorajamento.',

  kiosk: {
    make_pay: 'Faça um pagamento',
    product_name: 'Nome do Produto',
    amount_payment: 'Quantidade de pagamento',
    may_pay_guide_txt:
      'O pagamento é concluído digitalizando o <br /><span style="font-weight:900; color:#2369b0;">código QR de pagamento ONEWORLDPAY {os}</span> <br />no terminal.',
    app_download_btn: 'Instale o ONEWORLDPAY {os}',
    app_download_qr_scan: 'Digitalize o código QR para baixar o aplicativo.',
    app_install_txt:
      'Leia o código QR abaixo e instale o <span style="font-weight: 900; color: #1f67af">ONEWORLDPAY {os}</span>',
    app_install_sub_txt:
      'Página de pagamento ONEWORLDPAY Digitalize o código QR no terminal para prosseguir com o pagamento.',
    app_install_sub_txt2:
      'O serviço ONEWORLDPAY ios será fornecido posteriormente.',
    direct_exchange_txt:
      '<strong>Troque </strong><strong>{asset1} </strong><span>por </span> <strong>{asset2}.</strong>',
    bank_use: 'usar banco',
    cocobank: 'ONEWORLDPAY',
    cocobank_account_transfer: 'Transferência de conta ONEWORLDPAY',
    store_use: 'pedido',
    location_store: 'co.u co.u',
    home_ad_1: 'Primeiro mercado aberto de moedas do mundo',
    home_ad_2: 'COCO MARKET',
    use: 'Como usar',
    bank_direct_ex: 'Eu vou trocar dinheiro agora mesmo',
    deposit_inquiry: 'Inquérito',
    deposit_inquiry_txt: 'Verifique a conta ONEWORLDPAY',
    deposit_withdrawal: 'Retirado',
    deposit_withdrawal_txt: 'Isso levará de 10 a 10 minutos após a aplicação',
    deposit_transfer: 'Transferir',
    deposit_transfer_txt: 'Remessa para conta ONEWORLDPAY',
    wallet_transfer: 'Transferência de carteira',
    wallet_transfer_txt: 'Transferindo para outra carteira de bolsa',
    exchange_list: 'Histórico de câmbio',
    certified: 'Gestão de certificação',
    certified_drawer_title: 'Gestão de certificação',
    direct_transaction: 'Transação direta',
    direct_transaction_txt: 'Troca imediatamente',
    c2c_transaction: 'Transação C2C',
    c2c_transaction_txt: 'Negociação criptográfica do cliente',
    account_application: 'Pedido de conta',
    account_application_txt: 'Inscreva-se para uma conta',
    terms_title1:
      'Guia para limitar os limites para prevenir o fortalecimento da fraude financeira em telecomunicações',
    terms_text1:
      'Como a conta solicitada é aberta de forma não face a face, o limite de retirada (transferência) por meio de dispositivos automatizados e da Internet é limitado a 0 CCF por dia. <br /> Dados de autenticação objetivos para confirmar o propósito da transação são apresentados ao agência e "gerenciamento> Você pode cancelar o limite em" Autenticação / Gerenciamento de segurança ". <br /> Ao usar o Internet banking, você deve se registrar como uma conta de saque para fazer transações de transferência. <br /> O limite por conta de criptomoeda é abra apenas 5 por pessoa Você pode.',
    terms_notice1: 'Aviso prévio',
    terms_notice1_txt:
      'A assinatura de banco pela Internet pode ser aplicada vinculando-se a partir da tela de conclusão após a abertura de uma conta de depósito e retirada. <br /> Os clientes existentes de banco pela Internet podem se registrar para contas de retirada por meio de banco pela Internet apenas quando a categoria de registro da conta de retirada for Internet + agência. Observe que existe.',
    terms_notice2:
      '&#8251; Se você prosseguir com a autenticação de segurança primeiro, deverá criar uma conta e registrar-se como uma conta de retirada ao usar o Internet banking antes de poder transferir transações.',
    cancel: 'cancelar',
    security_authentication: 'Autenticação de segurança',
    new_registration: 'Novo registro',
    terms_title2:
      'Ao clicar no novo botão de inscrição, você receberá sua própria conta {0} Cocobank e endereço de depósito vinculado à carteira externa.',
    terms_notice3: 'Certifique-se de saber antes de depositar!',
    terms_notice3_text1:
      'Apenas {0} pode ser depositado na conta / endereço emitido no novo registro. Erros / perdas que podem ocorrer se você tentar depositar outros ativos digitais no endereço são irrecuperáveis.',
    terms_notice3_text2:
      'Depois de ocorrer uma confirmação, ela é refletida no saldo por meio do processo de depósito. O processo de depósito é automático e o tempo necessário pode variar dependendo das condições da rede.',
    terms_notice3_text3:
      'O endereço acima é <strong> Somente Depósito </strong>.',
    terms_checkbox_text: 'Você concordou e entendeu o acima?',
    assets: 'Ativos',
    favorite: 'Favoritos',
    select_assets_txt: 'Selecione um ativo.',
    search_assets: 'Busca de ativos',
    search_assets_txt: 'Por favor, procure um ativo.',
    account_name: 'Nome da conta',
    account_name_txt: 'Por favor insira o nome da sua conta',
    selected_assets: 'Ativo opcional',
    account_unique_number: 'Número exclusivo da conta',
    account_number: 'Número da conta',
    stop_amount: 'Quantidade de parada',
    state: 'Estado',
    auto_input: 'Entrada automática',
    opening: 'Abertura',
    application_success_txt: 'A inscrição da conta foi concluída.',
    application_fail_text: 'A aplicação da conta falhou.',
    confirm: 'confirme',
    previous: 'anterior',
    enter_account_number: 'Por favor, insira o número da sua conta.',
    service_preparation: 'Preparando o serviço',
    service_preparation_txt1:
      'Estamos preparando a página para prestar um melhor atendimento.',
    service_preparation_txt2: 'Estaremos prontos e nos vemos em breve.',
    search_account: 'Pesquisa de conta',
    search_account_txt: 'Por favor, procure sua conta.',
    select_account_txt: 'Selecione uma conta.',
    withdrawable_amount: 'Montante a retirar',
    inquiry_period: 'Período de inquérito',
    variable_amount: 'quantidade variável',
    no_deposit_history: 'Não há histórico de consulta de depósito.',
    select_date: 'Por favor selecione uma data',
    type_of_change: 'Tipo de mudança',
    sort_order: 'Ordem de classificação',
    inquiry_option: 'Opção de consulta',
    select_market: 'Seleção de mercado',
    reduction_rate: 'taxa de comissão',
    sales_quantity: 'Quantidade de vendas',
    minimum_purchase_quantity: 'Quantidade mínima de compra',
    selling_price_per_piece: 'Preço de venda por peça',
    account_for_registration_of_sales: 'Conta para registro de vendas',
    purchase_assets: 'Compra de ativos',
    available_quantity: 'Quantidade disponível',
    purchase_quantity: 'Quantidade de compra',
    price_per_piece: 'Preço por peça',
    quantity_to_be_paid: 'Quantidade a pagar',
    select_account_to_receive: 'Selecione a conta para receber',
    registration_was_successful: 'Registro com sucesso',
    registration_failed: 'Registração falhou.',
    go_to_first: 'Pela primeira vez',
    purchase_history: 'compra história',
    purchase_price: 'Preço de compra',
    no_description: 'Não há descrição.',
    sales_history: 'Histórico de vendas',
    price_per_quantity: 'Preço por quantidade',
    total_fee: 'Taxa total',
    no_disclosure_details: 'Não há detalhes de divulgação.',
    advanced_search: 'Busca Avançada',
    sales_registration: 'Registro de vendas',
    purchase_registration: 'Registro de compra',
    verification_completed: 'Verificação concluída',
    email_authentication: 'Autenticação do email',
    authenticate: 'Autenticar',
    identity_verification: 'Verificação de Identidade',
    otp_authentication: 'Autenticação OTP',
    withdrawal_address_verification: 'Verificação do endereço de retirada',
    withdrawal_address_application_details:
      'Detalhes do pedido de endereço de retirada',
    no_withdrawal_address_application_details:
      'Não há solicitação de endereço de retirada.',
    kyc_authentication: 'Autenticação KYC',
    kyc_application_details: 'Detalhes do aplicativo KYC',
    security_level: 'Nível de segurança',
    view_rating: 'Ver classificação',
    no_account_alias: '(Sem alias de conta)',
    no_choice: '(Sem escolha)',
    select_coin_to_exchange: 'selecione a moeda para trocar',
    sending_verification_email: 'Enviando e-mail de verificação',
    sending_verification_email_txt: 'Clique em Enviar e-mail de verificação.',
    enter_verification_code: 'Autenticar',
    enter_verification_code_txt: 'Por favor, insira o código de verificação.',
    verification_email_has_been_sent: 'Um e-mail de verificação foi enviado.',
    base_asset_account_information: 'Informações da conta do ativo básico',
    classification_of_transactions: 'Classificação de transação',
    logged_out_txt: 'Você está desconectado.',
    check_logged_out_txt: 'Você quer sair',
    scan_qr_code_txt: 'Leia o código QR abaixo.',
    simple_login: 'Login simples',
    simple_login_txt: 'Digite o código de verificação de login simples.',
    be_loggin_in: 'Você está logando.',
    be_logged_in: 'Você está logado.',
    step_one: 'Passo 1',
    step_one_txt: 'Instale o Google OTP da App Store para autenticação OTP.',
    step_two: 'Passo 2',
    step_two_txt:
      'Imprima ou escreva o código de 16 dígitos emitido. Este código é usado para recuperação em caso de perda / substituição ou exclusão do celular.',
    step_three: 'etapa 3',
    step_three_txt:
      'Leia o código QR abaixo com o aplicativo Google Authenticaror instalado.',
    step_four: 'Passo 4',
    step_four_txt:
      'Digite o código de verificação OTP de 6 dígitos gerado e clique em Autenticar.',
    mobile_authentication: 'Autenticação de telefone celular',
    mobile_authentication_txt:
      'A autenticação é realizada por meio de um telefone celular em nome da pessoa.',
    do_mobile_authentication: 'Autenticação de telefone',
    complete_mobile_authentication: 'A autenticação está completa',
    failed_mobile_authentication: 'A autenticação falhou.',
    transfer_quantity: 'Quantidade de transferência',
    enter_transfer_quantity: 'Insira a quantidade de transferência.',
    transfer_quantity_2: 'Quantidade de transferência',
    enter_transfer_quantity_2: 'Insira a quantidade de transferência.',
    select_transfer_quantity: 'Selecione a quantidade de transferência.',
    enter_transfer_account_number:
      'Por favor, insira o número da conta de transferência.',
    current_security_level: 'Seu nível de segurança atual',
    choose_how_to_pay_the_fee: 'Escolha como pagar a taxa',
    confirm_withdrawal_application_information:
      'Confirme as informações do pedido de retirada',
    enter_login_code_txt:
      'Leia o código QR para verificação de login simples exibido na tela do terminal <br/> no leitor de código de barras abaixo ou digite o código de verificação simples no campo abaixo.',
    direct_ex_manual: 'Como usar a troca direta de moeda',
    deposit_transfer_manual: 'Como usar a remessa de depósito',
    deposit_inquiry_txt_manual: 'Como usar consultas de depósito',
    deposit_withdrawal_manual: 'Como usar a retirada de depósito',
    wallet_transfer_manual: 'Como usar a transferência de carteira',
    buy_with_coin_selected_account: 'Compre com {code} da conta selecionada',
    sell_with_coin_selected_account: 'Venda {code} na conta selecionada.',
    receive_purchased_coin:
      'Selecione uma conta para receber o {code} comprado.',
    receive_converted_coin:
      'Selecione uma conta para receber o {code} convertido.',
    enter_account_holder: 'Por favor, insira o nome do titular da conta.',
    enter_account: 'Por favor, insira o número da sua conta.',
    enter_withdrawal: 'Por favor, insira o valor da retirada.',
    transfer_to_another_wallet: 'Transferir para outra carteira',
    invalid_login_code: 'Código de autenticação de login inválido.',
    payment_canceled: 'O pagamento foi cancelado',
  },

  market_balance: {
    deposit_successful: 'O depósito foi realizado com sucesso.',
    wthdrawal_successful: 'A retirada foi bem-sucedida. ',
    deposit: 'Depósito',
    withdrawal: 'Retirada',
    select_account: 'Selecione a conta',
    assets: 'Ativos',
    select_market: 'Seleção de mercado',
    quantity: 'Quantidade',
    confirm: 'confirme',
  },
  pop_notice: {
    notice_close: 'fechar',
    notice_today: 'Não vendo hoje',
  },
  private_notice: {
    msg_false_deal_title: 'Ela proíbe as divulgações falsas',
    msg_false_deal_content_1:
      'Os vendedores devem ter uma senha, por favor poste a moeda de transação necessários para vender o suficiente.',
    msg_false_deal_content_2:
      'restrições impostas à utilização de serviços da cidade continuou a realizar uma falsa divulgação, por favor note que a bagagem.',
    msg_deal_confirm_click_title: 'Confirmado no clique de um botão Notas',
    msg_deal_confirm_click_content_1:
      "O vendedor, não se esqueça de clicar em 'confirmar' botão, em seguida, certifique-se de verificar o pagamento do comprador.",
    msg_deal_confirm_click_content_2:
      'bancos de coco não são legalmente responsáveis ​​por danos monetários causados ​​por negligência do vendedor. Certifique-se de verificar se os compradores de pay.',
    msg_deal_confirm_not_click_title:
      'Quando não está pressionado o botão confirmar',
    msg_deal_confirm_not_click_content_1:
      'O vendedor paga o confirm comprador se você deve clicar no botão "Confirmar".',
    msg_deal_confirm_not_click_content_2:
      "Impôs restrições aos serviços utilizados pelo gerente quando não clicar no 'confirmar' botão Note bagagem.",
    msg_c2c_title: 'transações C2C',
    msg_c2c_content_1:
      'transações C2C baseiam-se nas actividades de livre comércio do vendedor e do comprador.',
    msg_c2c_content_2:
      'O banco Coco só fornece serviços de plataforma para transações convenientes e seguras para vendedores e compradores.',
    msg_c2c_content_3:
      'bancos Coco ter ocorrido durante a disputa legal entre o vendedor eo comprador, por favor nota que apenas um papel responsável em juízo.',
    msg_false_hold_title: 'Proibir a falsa segurando',
    msg_false_hold_content_1:
      "O comprador deve ter certeza de clicar no 'hold' após o pagamento tenha sido concluída para a negociação C2C.",
    msg_false_hold_content_2:
      'Qualquer disputa entre o vendedor eo comprador decorrentes da exploração não é responsável por qualquer banco Coco fraudulenta.',
    msg_false_hold_content_3:
      'Esta restrição também se aplica ao uso de serviços da cidade continuar a desempenhar o falso realização Por favor, note que a bagagem.',
    msg_false_hold_content_4:
      'Se não há nenhuma confirmação depois de completar o seu pagamento, entre em contato com o administrador tem através do contato one-on-one.',
    msg_false_hold_content_5:
      'Quando as transações C2C via a carteira externa no caso de você pode ser cobrada uma taxa que não tenha realizado corretamente transações C2C pode ser inconveniente para essas operações resolvidos.',
  },
  kiosk_re: {
    choice_lang: 'Selecione o idioma',
    buy_immedi:
      'Se você usar o Coco Bank, você pode comprar <span>imediatamente com</span>.',
    new_acc: 'Criação da conta bancária de Coco',
    join_txt:
      'Quando você usa um total externo e uma conta, você precisa fazer uma reserva de compra, mas precisa verificar o vendedor, mas pode comprá-lo imediatamente usando o Banco Coco. Não recebemos uma taxa no Banco Cocoe apoiamos o movimento entre os ativos de senha mais rápidos do mundo.',
    main_order_txt: 'Cartão de crédito / compra de senha de ativos',
    main_bank_txt: 'Ativos de senha Armazenamento e compra / venda',
    main_market_txt: 'Ativos de senha on-line Open Market',
    main_about: 'Coinabout',
    main_about_txt: 'Notícias profissionais para ativos de senha',
    about_drw_txt_1:
      'Receba rapidamente e vários blocos de notícias de <span>moeda</span>.',
    about_drw_txt_2:
      'A Coinea Boute oferece notícias rápidas e análise para bloquear a cadeia e os t-shirt.',
    about_drw_txt_3:
      'Quando você digitaliza o código QR, a coinea está conectada ao nariz.',
    market_drw_txt_1: 'Agora fazer compras com <span>ativos virtuais</span>.',
    market_drw_txt_2:
      'Nosso mercado de Coco é um mercado aberto que permite comprar mercadorias com o primeiro ativo virtual na Coréia.',
    market_drw_txt_3:
      'Quando você digitalizar o código QR, ele será conectado ao mercado de Coco.',
    market_drw_txt_4:
      'Os mercados de coco criarão muitos produtos e vários ativos virtuais e sistemas de pagamento.',
    login_title: 'Digitalize o código <span> qr abaixo.',
    login_txt_1: 'As informações do usuário são necessárias para uso.',
    login_txt_2:
      'Por favor, insira o código de autenticação de login simples exibido na tela do terminal no campo abaixo.',
    code_txt:
      'Log simples de <br><span>Digite o código de autenticação</span>.',
    new_acc_tit_1: 'Criar nova conta',
    new_acc_tit_2:
      'Por favor, verifique o conteúdo necessário para criar novas contas.',
    new_acc_txt_1:
      'Hangha para prevenção de fraude financeira de telecomunicações',
    new_acc_txt_2:
      '* Para garantir que você seja mais fácil realizar sua transferência para o Internet Banking, você precisará ser uma autenticação segura. Após o processo de certificação, por favor, melhore a classificação e prossiga com a contabilidade e arranjo do sistema de contabilidade.',
    new_acc_txt_3:
      'Se você transferir para sua conta de uma conta dedicada do Coco Bank para sua conta, você não será capaz de pagar. Contas / endereços emitidos por novas entradas podem ser depositadas apenas com {0}. Erro / perda que pode ocorrer se você tentar depositar diferentes ativos digitais com esse endereço não é recuperável. Depois que ocorrer uma confirmação, ela se reflete no saldo através do processo de depósito. O processo de depósito continuará automaticamente e o tempo necessário depende da situação da rede. O endereço acima é um endereço dedicado de depósito.',
    new_acc_txt_4:
      'Você pode depositar {0} como uma nova assinatura atribuída à sua associação.',
    new_acc_btn_agr: 'Abrindo o consentimento e conta',
    new_acc_txt_5: 'Uma nova conta foi aberta.',
    new_acc_txt_6:
      'Os serviços bancários do Coco estão disponíveis na conta estabelecida.',
    charge_tit_1: 'Cobrar {0}.',
    charge_tit_2:
      'Por favor, selecione um ativo para ser usado para carregar {0}.',
    charge_tit_3:
      'Por favor, insira sua conta e insira a quantidade de ativos a ser usada para carregar.',
    charge_txt_1: 'Taxa de referência de carga',
    charge_txt_2: 'Tipo de carga',
    charge_txt_3: 'Quantidade padrão',
    charge_txt_4: 'Capacidade de carga',
    charge_txt_5: 'Carregamento',
    charge_txt_6: 'O carregamento está completo.',
    charge_txt_7: 'Retorna à tela principal após 3 segundos.',
    complete: 'Selecione Conclusão.',
    input_complete: 'Conclusão de entrada',
    quan_max: 'máximo',
    buy_reserv: 'Assinou uma reserva de compra',
    krw_dialog_tit:
      'Por favor, clique no botão Agendamento de Reservas após o depósito.',
    krw_dialog_txt_1:
      'Quando você clica na reserva de pré-compra, sua carteira e contas são congeladas, e o comprador finalmente clica na quantidade de compras para o vendedor, e o vendedor notificará o vendedor, e o vendedor poderá comprar a compra. Os ativos que você comprou serão depositados.',
    krw_dialog_txt_2:
      '* Se o depósito não for fixado na compra em 3 horas, uma carteira de congelamento e conta estarão disponíveis. Se você não deposit, entre em contato com o Centro de Clientes se não depositá-lo em 1 hora.',
    krw_dialog_txt_3:
      'O comprador apenas reservas e se o depósito não for mais de três vezes, o ID é interrompido.',
    purchase: 'Comprar ativos',
    payable: 'Ativos de pagamento',
    purchase_choice: 'Selecione Comprar ativo.',
    payable_choice: 'Selecione Ativos de pagamento',
    latest_order: 'Mais recente',
    low_price: 'Preço baixo',
    high_price: 'Preço Alto',
    seller: 'vendedor',
    search_seller: 'Procure pelo vendedor.',
    no_regist: 'Não há produto de vendas registrado.',
    other_seller: 'Por favor, procure por outros vendedores.',
    pur_quan: 'Quantidade de compra',
    buy_quan: 'Quantidade de pagamento',
    bank_txt_1:
      'Você pode ver a lista de compras quando <span class = "color-blue"> adquirir ativos </span> e <span class = "color-green"> ativo de pagamento </span>.',
    sale_regist: 'Registre sua divulgação de vendas',
    bank_drw_tit: 'Registro de divulgação de vendas',
    bank_drw_txt_1:
      'O registro de divulgação de vendas pode ser registrado no celular.',
    bank_drw_txt_2:
      'Quando você digitaliza o código QR, você estará vinculado à página de registro de divulgação de vendas.',
    total_charge: 'Quantidade final de carga',
    detail_tit:
      '<strong>Por favor, verifique as informações de compra</strong>.',
    detail_sub:
      'Você precisa de uma conta para sua compra. por favor selecione.',
    pur_assets: 'Comprar ativos',
    acc_receive: 'Selecione a conta para receber',
    seller_acc_info: 'informações de conta de vendedor',
    krw_txt: 'Coco Bank não deposita ou salva KRW (ganhou).',
    total_payble: 'Ativos de pagamento final',
    purch_reser: 'reserva de compra',
    buy: 'Compra',
    buy_suc: 'A compra está completa.',
  },
}
